<template>
	<span>
	<header>
		<section id="top">
			<label for="menu" class="dv_mobile" v-on:click="toggleBurgerMenu"><img src="img/ico_11_menu.svg" /></label>
<!--			<input type="checkbox" id="menu" class="hidden" />-->
			<img src="img/logo.png"/>
			<nav class="dv_tablet-dv_fullscreen" v-bind:class="{'active':burgerMenu}">
				<menu>
					<li><a href="#" v-on:click="WsScrollTo('top',     $event)" class="action">Главная</a></li>
					<li><a href="#" v-on:click="WsScrollTo('zaim',    $event)">Как быстро получить займ?</a></li>
					<li><a href="#" v-on:click="WsScrollTo('preim',   $event)">Преимущества</a></li>
					<li><a href="#" v-on:click="WsScrollTo('uslov',   $event)">Условия</a></li>
					<li><a href="#" v-on:click="WsScrollTo('contact', $event)">Контакты</a></li>
				</menu>
			</nav>
			<hgroup class="dv_tablet-dv_fullscreen">
				<img src="img/ico_1_mail.svg" />
				<div>
					<b><a href="mailto:help@msk.finmoll.com">help@msk.finmoll.com</a></b>
					<span>c 9:00 до 21:00, без выходных</span>
				</div>
			</hgroup>
			<hgroup class="dv_tablet-dv_fullscreen">
				<img src="img/ico_2_phone.svg" />
				<div>
					<b><a href="tel:88006009990">8 800 600 99 90</a></b>
					<span>звонок бесплатный по РФ</span>
				</div>
			</hgroup>
			<a href="tel:88006009990"><img src="../../public/img/ico_2_phone_b.svg" class="dv_mobile" /></a>
		</section>
	</header>
	<section class="bone">
		<article>
			<div>
				<h2>Займы до 100 000 ₽ <br />без кредитной <br />истории</h2>
				<p>Отправьте заявку и получите <br />возможность поступления <br />денег уже сегодня!</p>
				<span>Срок займа <b>до <span>1</span> года</b></span>
			</div>
			<article>
				<h3>Выберите сумму займа</h3>
				<div>
					<p>Вы получите:<b>{{summVuex}} ₽</b>на {{minBaseProduct.Period}} недель</p>
					<sorslid name="spon"></sorslid>
					<p class="pa">от {{rangeMin}} ₽</p>
					<p class="pb">до {{rangeMax}} ₽</p>
					<br style="clear: both;" />
				</div>
				<h2>Условия займа*</h2>
				<dl>
					<dt>Вы получите:</dt>
					<dd>{{paymentInfo.Amount}} ₽</dd>
					<dt>На срок:</dt>
					<dd>{{minBaseProduct.Period}} недель ({{FixedPay | moneyFormat}} ₽/нед)**</dd>
<!--					<dt v-on:click="WsScrollTo('contact', $event)" style="text-decoration: underline;">Со ставкой:</dt>-->
<!--					<dd  v-on:click="WsScrollTo('contact', $event)">от 199,594% до 200,000% годовых*</dd>-->
<!--					<dd v-show="paymentInfo.Amount <= 47000" v-on:click="WsScrollTo('contact', $event)">220% годовых*</dd>-->
<!--					<dd v-show="paymentInfo.Amount >  47000" v-on:click="WsScrollTo('contact', $event)">200% годовых*</dd>-->
				</dl>
				<button v-on:click="WsScrollTo('zform', $event)">Получить деньги</button>
<!--        <p class="subtext2406">**Данный калькулятор носить исключительно демонстрационный характер, представленные в калькуляторе расчеты являются информационными и могут не соответствовать согласованным условиям договора займа. Все условия договора займа подлежат согласованию при заключении договора займа в соответствии с <a target="_blank" href="/admd/pdf/2024.04.02Information_about_the_conditions_for_providing microloans_print.pdf">Информацией об условиях предоставления, использования и возврата потребительского микрозайма ООО МКК «ФИНМОЛЛ».</a></p>-->
			</article>
			<br style="clear: both;" />
		</article>
	</section>
    <banner></banner>
<!--    <section class="banner">-->
<!--      <article>-->
<!--        <p>-->
<!--          Станьте участником розыгрыша<br>-->
<!--          10 сертификатов по 3000 рублей-->
<!--        </p>-->
<!--        <p>-->
<!--          <span>Установите</span> мобильное приложение<br> и <span>внесите</span> онлайн-платеж-->
<!--        </p>-->
<!--        <div>-->
<!--          <a target="_blank" href="https://play.google.com/store/apps/details?id=ru.finmoll.customer&hl=ru&clckid=6e94573d">-->
<!--          <svg viewBox="0 0 246 73" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M236.889 0H9.111C4.08 0 0 4.085 0 9.125v54.75C0 68.915 4.08 73 9.111 73H236.89c5.032 0 9.111-4.085 9.111-9.125V9.125C246 4.085 241.921 0 236.889 0z" fill="#000"/><path d="M124.166 39.694a7.736 7.736 0 00-4.292 1.325 7.757 7.757 0 00-3.262 7.966 7.757 7.757 0 006.093 6.075 7.735 7.735 0 007.94-3.305 7.767 7.767 0 001.302-4.305 7.658 7.658 0 00-2.248-5.53 7.638 7.638 0 00-5.533-2.226zm0 12.464a4.695 4.695 0 01-4.57-2.667 4.717 4.717 0 01.8-5.236 4.701 4.701 0 015.157-1.178 4.703 4.703 0 012.987 4.373 4.508 4.508 0 01-1.195 3.278 4.486 4.486 0 01-3.179 1.43zm-16.965-12.464a7.736 7.736 0 00-7.141 4.8 7.764 7.764 0 001.69 8.447 7.742 7.742 0 008.438 1.673 7.745 7.745 0 003.472-2.857 7.766 7.766 0 001.304-4.307 7.64 7.64 0 00-2.248-5.53 7.638 7.638 0 00-5.533-2.226h.018zm0 12.464a4.694 4.694 0 01-4.582-2.653 4.72 4.72 0 01.787-5.242 4.703 4.703 0 015.159-1.186 4.703 4.703 0 012.992 4.373 4.508 4.508 0 01-1.196 3.278 4.472 4.472 0 01-3.178 1.43h.018zM86.993 42.084v3.285h7.872a6.885 6.885 0 01-1.822 4.143 8.053 8.053 0 01-6.068 2.41 8.74 8.74 0 01-6.185-2.566 8.767 8.767 0 010-12.389 8.74 8.74 0 016.185-2.566 8.375 8.375 0 015.959 2.354l2.314-2.317a11.461 11.461 0 00-8.255-3.413 12.03 12.03 0 00-8.818 3.36 12.062 12.062 0 00-3.695 8.694 12.078 12.078 0 003.695 8.694 12.041 12.041 0 008.818 3.36 10.92 10.92 0 008.4-3.376 10.96 10.96 0 002.843-7.701 10.726 10.726 0 00-.182-2.063l-11.061.091zm82.565 2.555a7.284 7.284 0 00-6.633-4.946 7.282 7.282 0 00-6.87 4.823 7.304 7.304 0 00-.419 2.934 7.603 7.603 0 002.2 5.514 7.574 7.574 0 005.49 2.242 7.698 7.698 0 006.451-3.43l-2.643-1.826a4.424 4.424 0 01-3.808 2.154 3.93 3.93 0 01-3.754-2.355l10.369-4.288-.383-.822zm-10.569 2.592a4.262 4.262 0 011.073-3.114 4.253 4.253 0 012.972-1.412 3.003 3.003 0 012.879 1.642l-6.924 2.884zm-8.419 7.519h3.408V31.937h-3.408V54.75zm-5.576-13.322h-.127a5.474 5.474 0 00-4.082-1.825 7.757 7.757 0 00-5.244 2.402 7.778 7.778 0 005.244 13.128 5.277 5.277 0 004.082-1.825h.109v1.114c0 2.974-1.585 4.562-4.136 4.562a4.277 4.277 0 01-3.9-2.756l-2.97 1.241a7.389 7.389 0 002.736 3.342 7.371 7.371 0 004.134 1.239c3.99 0 7.289-2.354 7.289-8.085V40.15h-3.135v1.278zm-3.899 10.73a4.712 4.712 0 01-3.066-1.516 4.73 4.73 0 013.066-7.9 4.363 4.363 0 013.059 1.48 4.372 4.372 0 011.077 3.228 4.347 4.347 0 01-2.463 4.293 4.33 4.33 0 01-1.691.415h.018zm44.426-20.22h-8.146V54.75h3.408V46.1h4.756a7.075 7.075 0 005.337-1.885 7.1 7.1 0 001.67-8.03 7.1 7.1 0 00-4.143-3.862 7.075 7.075 0 00-2.864-.386h-.018zm0 10.95h-4.756v-7.775h4.828c1.037 0 2.031.412 2.764 1.147a3.918 3.918 0 010 5.536 3.905 3.905 0 01-2.764 1.146l-.072-.054zm21.01-3.285a6.37 6.37 0 00-6.068 3.485l3.025 1.26a3.227 3.227 0 013.097-1.68 3.28 3.28 0 013.645 2.939v.237a7.517 7.517 0 00-3.553-.876c-3.262 0-6.56 1.825-6.56 5.128a5.283 5.283 0 001.766 3.705 5.256 5.256 0 003.882 1.314 4.788 4.788 0 004.374-2.19h.109v1.825h3.28v-8.778c0-3.997-3.025-6.315-6.906-6.315l-.091-.054zm-.419 12.5c-1.112 0-2.661-.565-2.661-1.934 0-1.825 1.932-2.427 3.645-2.427a6.04 6.04 0 013.097.767 4.122 4.122 0 01-3.99 3.65l-.091-.055zm19.37-11.953l-3.9 9.892h-.109l-4.045-9.892h-3.645l6.068 13.834-3.462 7.683h3.553l9.33-21.517h-3.79zm-30.632 14.6h3.408V31.937h-3.408V54.75zM76.734 26.043h-1.348v-3.65h1.148a5.222 5.222 0 001.384-4.198v-5.42h7.29v9.6h1.22v3.65H85.08v-2.3h-8.346v2.318zm2.533-7.793a7.31 7.31 0 01-1.039 4.198h5.467v-8.322h-4.428v4.124zm18.058 4.052a5.68 5.68 0 01-8.018 0 5.917 5.917 0 010-8.122 5.647 5.647 0 016.18-1.237 5.647 5.647 0 011.838 1.237 5.9 5.9 0 010 8.122zm-6.979-.913a4.206 4.206 0 005.94 0 4.676 4.676 0 000-6.278 4.206 4.206 0 00-5.94 0 4.676 4.676 0 000 6.278zm15.671 2.573a5.566 5.566 0 01-4.06-1.64 5.582 5.582 0 01-1.625-4.072 5.586 5.586 0 013.488-5.308 5.564 5.564 0 012.197-.404 5.041 5.041 0 014.009 1.825l-.984.949a3.647 3.647 0 00-3.043-1.387 4.133 4.133 0 00-3.025 1.204 4.694 4.694 0 000 6.333 4.138 4.138 0 003.025 1.204 4.314 4.314 0 003.335-1.624l.984.986a5.32 5.32 0 01-1.823 1.423 5.729 5.729 0 01-2.478.511zm10.022-.237h-1.403v-9.6h-3.061v-1.35h7.507v1.35h-3.043v9.6zm12.701-10.95l-4.136 9.234a2.75 2.75 0 01-2.515 1.953 2.8 2.8 0 01-1.093-.237l.364-1.296c.222.13.473.199.729.201.268.02.535-.044.765-.182.22-.187.389-.425.492-.694l.401-.876-3.644-8.085h1.658l2.697 6.278 2.624-6.296h1.658zm1.586 10.95v-10.95h7.908v10.95h-1.403v-9.6h-5.102v9.6h-1.403zm10.404 0v-10.95h1.404v4.69h5.466v-4.69h1.403v10.95H147.6v-4.946h-5.466v4.946h-1.404zm19.735-1.424a5.68 5.68 0 01-8.018 0 5.92 5.92 0 010-8.12 5.648 5.648 0 016.18-1.238 5.638 5.638 0 011.838 1.237 5.897 5.897 0 010 8.122zm-6.979-.912a4.206 4.206 0 005.94 0 4.674 4.674 0 000-6.278 4.203 4.203 0 00-5.94 0 4.679 4.679 0 000 6.278zm14.323 2.336v-10.95h3.954a3.203 3.203 0 012.223.84 2.753 2.753 0 01.948 2.135c.008.486-.132.964-.401 1.369-.268.393-.64.703-1.075.894a2.77 2.77 0 011.33.949c.35.447.537 1 .528 1.57a2.86 2.86 0 01-.984 2.226 3.367 3.367 0 01-2.332.894l-4.191.073zm1.403-6.26h2.551a1.638 1.638 0 001.275-.529 1.618 1.618 0 00.423-1.791 1.627 1.627 0 00-.35-.545 1.562 1.562 0 00-1.221-.53h-2.605l-.073 3.395zm0 4.91h2.824a1.67 1.67 0 001.312-.566 1.82 1.82 0 00.51-1.241 1.821 1.821 0 00-1.822-1.825h-2.77l-.054 3.632z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M93.316 12.691a5.46 5.46 0 00-3.878 1.616 5.735 5.735 0 000 7.867 5.499 5.499 0 007.757 0 5.717 5.717 0 000-7.867 5.465 5.465 0 00-3.879-1.616zm-2.241.084a5.824 5.824 0 016.38 1.277l.002.003a6.082 6.082 0 010 8.372l-.003.004a5.863 5.863 0 01-8.275 0l-.004-.004a6.101 6.101 0 010-8.372l.003-.003a5.832 5.832 0 011.897-1.277zm65.381-.084a5.46 5.46 0 00-3.878 1.616 5.738 5.738 0 000 7.867 5.498 5.498 0 007.757 0 5.717 5.717 0 00-.001-7.867 5.45 5.45 0 00-3.878-1.616zm-2.241.084a5.823 5.823 0 016.379 1.277l.003.003a6.082 6.082 0 010 8.372l-.003.004a5.865 5.865 0 01-8.275 0l-.004-.004a6.102 6.102 0 010-8.372l.003-.003a5.834 5.834 0 011.897-1.277zm-46.06.38a4.855 4.855 0 00-2.133-.435h-.008a5.387 5.387 0 00-3.928 1.587 5.396 5.396 0 00-1.572 3.939v.008a5.41 5.41 0 001.572 3.938 5.394 5.394 0 003.928 1.588l.003.182.004-.182a5.55 5.55 0 002.398-.494 5.147 5.147 0 001.651-1.248l-.725-.726a4.49 4.49 0 01-3.343 1.537 4.313 4.313 0 01-3.156-1.258l-.007-.006a4.88 4.88 0 01.001-6.579l.005-.006a4.317 4.317 0 013.152-1.258 3.823 3.823 0 013.06 1.302l.719-.693a4.873 4.873 0 00-1.621-1.196zm-2.138 10.99a5.756 5.756 0 01-5.457-3.625 5.762 5.762 0 01-.41-2.27 5.762 5.762 0 011.678-4.2 5.767 5.767 0 014.189-1.695 5.222 5.222 0 014.149 1.891l.108.13-1.251 1.207-.124-.158a3.464 3.464 0 00-2.891-1.318h-.014a3.943 3.943 0 00-2.888 1.149 4.51 4.51 0 000 6.08 3.946 3.946 0 002.888 1.148h.003a4.127 4.127 0 003.194-1.556l.127-.159 1.245 1.247-.105.128a5.505 5.505 0 01-1.884 1.472l-.003.002a5.917 5.917 0 01-2.554.527zm67.846-10.396a3.021 3.021 0 00-2.097-.792h-3.775V23.54l4.006-.07h.005a3.186 3.186 0 002.207-.845l.004-.004a2.692 2.692 0 00.921-2.085v-.006a2.3 2.3 0 00-.49-1.455l-.001-.001a2.588 2.588 0 00-1.243-.887l-.45-.15.434-.19c.404-.178.749-.465.998-.83.248-.373.377-.814.369-1.263v-.007a2.566 2.566 0 00-.884-1.994l-.004-.003zm.244-.27a3.385 3.385 0 00-2.346-.886h-4.135V23.91l4.371-.077H172a3.55 3.55 0 002.454-.94 3.059 3.059 0 001.045-2.363l-.001.003-.182-.003.182-.004.001.004a2.67 2.67 0 00-.567-1.681 2.954 2.954 0 00-1.046-.859c.315-.198.586-.46.797-.77l.001-.001c.29-.435.44-.948.432-1.47v.003l-.182-.003.182-.004v.004a2.932 2.932 0 00-1.009-2.272zm-96.37-.886h7.653v9.599h1.22v4.015h-1.712v-2.3h-7.982v2.318h-1.713V22.21h1.251a5.039 5.039 0 001.284-3.993l-.002-.011v-5.614zm.364.364v5.227a5.411 5.411 0 01-1.435 4.334l-.054.057h-1.044v3.285h.984v-2.317h8.71v2.299h.984v-3.285h-1.22v-9.6H78.1zm33.292-.365h7.872v1.716h-3.043v9.6h-1.768v-9.6h-3.061v-1.716zm.364.365v.986h3.061v9.6h1.039v-9.6h3.043v-.986h-7.143zm15.204-.365h2.061l-4.247 9.482a2.935 2.935 0 01-2.678 2.07l-.01.001a2.983 2.983 0 01-1.164-.253l-.146-.064.472-1.675.203.119c.194.113.414.173.639.176h.012c.225.017.45-.035.645-.15.191-.164.338-.374.428-.61l.005-.01.366-.8-3.726-8.267h2.06l2.574 5.993 2.506-6.011zm.242.365l-2.742 6.582-2.82-6.563h-1.256l3.563 7.903-.434.946c-.114.295-.3.557-.542.762l-.011.01-.012.007c-.261.157-.564.23-.868.208a1.659 1.659 0 01-.605-.123l-.261.928c.279.103.574.158.871.163a2.567 2.567 0 002.343-1.824l.004-.01 4.026-8.989h-1.256zm2.94-.365h8.273v11.315h-1.767v-9.599h-4.738v9.6h-1.768V12.591zm.365.365v10.585h1.038v-9.599h5.467v9.6h1.039V12.957h-7.544zm10.04-.365h1.768v4.69h5.102v-4.69h1.768v11.315h-1.768v-4.945h-5.102v4.945h-1.768V12.592zm.365.365v10.585h1.038v-4.945h5.831v4.945h1.039V12.957h-1.039v4.69h-5.831v-4.69h-1.038zm-50.696 2.025a4.388 4.388 0 016.198 0l.007.006a4.859 4.859 0 010 6.524l-.007.006a4.388 4.388 0 01-6.198 0l.129-.129-.135.123a4.858 4.858 0 010-6.524l.007-.006zm.26 6.28a4.024 4.024 0 005.678 0 4.493 4.493 0 000-6.025 4.024 4.024 0 00-5.677 0 4.493 4.493 0 000 6.026zm62.88-6.28a4.391 4.391 0 016.198 0l.007.006a4.858 4.858 0 01-.001 6.524l-.006.006a4.388 4.388 0 01-6.198 0l.129-.129-.135.123a4.858 4.858 0 010-6.524l.006-.006zm.261 6.281a4.023 4.023 0 005.677 0 4.494 4.494 0 000-6.026 4.026 4.026 0 00-5.677 0 4.495 4.495 0 000 6.026zm18.27-7.375a1.75 1.75 0 011.357.588 1.799 1.799 0 01.507 1.313 1.81 1.81 0 01-.585 1.277 1.82 1.82 0 01-1.408.582h-2.733l.08-3.76h2.782zm.599.479a1.378 1.378 0 00-.591-.114h-2.433l-.065 3.03h2.373a1.455 1.455 0 001.133-.47l.006-.007.006-.005a1.444 1.444 0 00.065-2.074l-.006-.006a1.387 1.387 0 00-.488-.354zm-93.402-.424h4.792v8.687h-5.972l.167-.277a7.126 7.126 0 001.013-4.093v-4.317zm.364.365v3.937a7.492 7.492 0 01-.906 4.02h4.97v-7.957h-4.064zm89.638 4.252h2.949a2.004 2.004 0 012.005 2.008v.002a2.008 2.008 0 01-.559 1.363 1.854 1.854 0 01-1.449.624h-3.006l.06-3.997zm.359.365l-.049 3.267h2.645a1.492 1.492 0 001.17-.504l.005-.006c.289-.3.453-.699.459-1.116a1.643 1.643 0 00-1.64-1.64h-2.59z" fill="#fff"/><path d="M19.024 13.76a3.654 3.654 0 00-.838 2.556v40.368a3.654 3.654 0 00.838 2.556l.127.127L41.73 36.774v-.53L19.15 13.634l-.127.128z" fill="url(#paint0_linear_29_20)"/><path d="M49.2 44.311l-7.471-7.537v-.53l7.47-7.555.165.091 8.947 5.092c2.551 1.442 2.551 3.814 0 5.274l-8.91 5.074-.201.091z" fill="url(#paint1_linear_29_20)"/><path d="M49.419 44.202l-7.69-7.702-22.705 22.74a2.968 2.968 0 003.79.109l26.623-15.147" fill="url(#paint2_linear_29_20)"/><path d="M49.419 28.799L22.796 13.65a2.967 2.967 0 00-3.79.11L41.729 36.5l7.69-7.701z" fill="url(#paint3_linear_29_20)"/><path opacity=".2" d="M49.2 44.037L22.796 59.093a3.04 3.04 0 01-3.645 0l-.127.128.127.128a3.022 3.022 0 003.645 0l26.623-15.147-.22-.165z" fill="#000"/><path opacity=".12" d="M19.024 58.984a3.654 3.654 0 01-.838-2.555v.274a3.654 3.654 0 00.838 2.555l.127-.128-.127-.146zM58.31 38.873L49.2 44.037l.164.165 8.947-5.074a3.19 3.19 0 001.822-2.628 3.396 3.396 0 01-1.822 2.373z" fill="#000"/><path opacity=".25" d="M22.796 13.906l35.515 20.22a3.39 3.39 0 011.822 2.373 3.197 3.197 0 00-1.822-2.628l-35.515-20.22c-2.551-1.442-4.628-.238-4.628 2.682v.274c.054-2.938 2.095-4.143 4.628-2.701z" fill="#fff"/><defs><linearGradient id="paint0_linear_29_20" x1="39.724" y1="15.896" x2="9.101" y2="46.473" gradientUnits="userSpaceOnUse"><stop stop-color="#00A0FF"/><stop offset=".01" stop-color="#00A1FF"/><stop offset=".26" stop-color="#00BEFF"/><stop offset=".51" stop-color="#00D2FF"/><stop offset=".76" stop-color="#00DFFF"/><stop offset="1" stop-color="#00E3FF"/></linearGradient><linearGradient id="paint1_linear_29_20" x1="61.646" y1="36.5" x2="17.566" y2="36.5" gradientUnits="userSpaceOnUse"><stop stop-color="#FFE000"/><stop offset=".41" stop-color="#FFBD00"/><stop offset=".78" stop-color="orange"/><stop offset="1" stop-color="#FF9C00"/></linearGradient><linearGradient id="paint2_linear_29_20" x1="45.246" y1="40.697" x2="3.709" y2="82.153" gradientUnits="userSpaceOnUse"><stop stop-color="#FF3A44"/><stop offset="1" stop-color="#C31162"/></linearGradient><linearGradient id="paint3_linear_29_20" x1="13.302" y1=".328" x2="31.844" y2="18.842" gradientUnits="userSpaceOnUse"><stop stop-color="#32A071"/><stop offset=".07" stop-color="#2DA771"/><stop offset=".48" stop-color="#15CF74"/><stop offset=".8" stop-color="#06E775"/><stop offset="1" stop-color="#00F076"/></linearGradient></defs></svg>-->
<!--        </a>-->
<!--        </div>-->
<!--        <p>-->
<!--          Организатор проведения акции ООО МКК «ФИНМОЛЛ» (ОГРН:<br class="mobileOnly"> 1117746509638, номер в реестре МФО: 651403550005541).<br>-->
<!--          Более подробную информацию об организаторе акции, месте ее<br class="mobileOnly"> проведения, правилах и порядке получения призов<br class="pcOnly">-->
<!--          уточняйте на <a href="https://lk.msk.finmoll.com/api/assets/pdf/RulesfortheincentiveeventInstalltheapplication.pdf" target="_blank">сайте</a><br class="mobileOnly"> или по телефону 8 800 600 99 90.<br>-->
<!--          Все представленные изображения являются компьютерной графикой. 18+</p>-->
<!--        <div class="phone">-->
<!--          <img src="../../public/img/fin-moll_banner_part.png">-->
<!--        </div>-->
<!--      </article>-->
<!--    </section>-->
	<section id="zform">
		<article class="sec_2">
			<loaderd v-if="isPostLoading"></loaderd>
      <esia v-on:scrollEvent="WsScrollTo('zform', $event)"></esia>
			<loader v-if="isLoading" object="#65C523" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
			<block1 v-if="systemFormVuex.currentFormScreen == 1" ></block1>
			<block2 v-if="systemFormVuex.currentFormScreen == 2" ></block2>
			<block3 v-if="systemFormVuex.currentFormScreen == 3" ></block3>
			<block4 v-if="systemFormVuex.currentFormScreen == 4" ></block4>
			<block5 v-if="systemFormVuex.currentFormScreen == 5" ></block5>
			<block6 v-if="systemFormVuex.currentFormScreen == 6" ></block6>
			<block7 v-if="systemFormVuex.currentFormScreen == 7" ></block7>
			<article class="dv_tablet-dv_fullscreen">
				<h3>Выберите сумму займа</h3>
				<div>
					<p>Вы получите:<b>{{ summVuex }} ₽</b>на {{ paymentInfo.Period }} {{ paymentInfo.PeriodType }}</p>
					<sorslid name="spon"></sorslid>
					<p class="pa">от {{ rangeMin }} ₽</p>
					<p class="pb">до {{ rangeMax }} ₽</p>
					<br style="clear: both;" />
				</div>
				<h2>Условия займа*</h2>
				<dl>
					<dt>Вы получите:</dt>
					<dd>{{ paymentInfo.Amount }} ₽</dd>
					<dt>На срок:</dt>
					<dd>{{ paymentInfo.Period }} недель ({{ FixedPay | moneyFormat }} ₽/нед)**</dd>
<!--					<dt v-on:click="WsScrollTo('contact', $event)" style="text-decoration: underline;">Со ставкой:</dt>-->
<!--					<dd  v-on:click="WsScrollTo('contact', $event)">от 199,594% до 200,000% годовых*</dd>-->
<!--					<dd v-show="paymentInfo.Amount <= 47000" v-on:click="WsScrollTo('contact', $event)">220% годовых*</dd>-->
<!--					<dd v-show="paymentInfo.Amount > 47000" v-on:click="WsScrollTo('contact', $event)">200% годовых*</dd>-->
				</dl>
        <p class="subtext2406"></p>
<!--        <p class="subtext2406 kostil">**Данный калькулятор носить исключительно демонстрационный характер, представленные в калькуляторе расчеты являются информационными и могут не соответствовать согласованным условиям договора займа. Все условия договора займа подлежат согласованию при заключении договора займа в соответствии с <a target="_blank" href="/admd/pdf/2024.04.02Information_about_the_conditions_for_providing microloans_print.pdf">Информацией об условиях предоставления, использования и возврата потребительского микрозайма ООО МКК «ФИНМОЛЛ».</a></p>-->
			</article>
			<hgroup>
				<div>
					<div>
						<h3>Еженедельный платёж составит:</h3>
						<h1>{{FixedPay | moneyFormat}} ₽ </h1>
					</div>
				</div>
				<div></div>
				<div>
					<p>Шаг {{systemFormVuex.currentFormScreen}} из 5</p>
					<button v-on:click="nextBlock($event)">следующий шаг</button>
				</div>
				<div> <img src="img/ico_10_lock.svg" /> <span>Гарантируем безопасность и сохранность ваших данных</span> </div>
				<div>
					<div><input type="checkbox" checked /></div>
					<label>Подтверждаю достоверность введенных данных и даю <wbr>согласие на обработку персональных данных
						<a href="https://lnd.msk.finmoll.com/assets/pdf/consent_to_PD_processing.pdf">Подробнее</a>
					</label>
				</div>
				<div>
					<div><input type="checkbox" checked /></div>
					<label>Подтверждаю достоверность введенных данных и даю <wbr>согласие на получение рекламы
						<a href="https://lnd.msk.finmoll.com/admd/upload/consentToAdvertising250530.pdf">Подробнее</a>
					</label>
				</div>
        <div style="width: 66%">
					<div><input type="checkbox" checked /></div>
					<label>Я согласен на получение Обществом с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ» (ИНН 7705954143, ОГРН 1117746509638) моего кредитного отчета, сформированного на основании моей кредитной истории в Бюро с целью возможного предоставления мне займа.
					</label>
				</div>
        <div>
					<div><input type="checkbox" checked /></div>
					<label>Соглашаюсь с Соглашением о рекурретных платежах<br><a href="https://finmoll.ru/backend/content/documents/agreement_recurring_payments" target="_blank">Открыть документ</a>
					</label>
				</div>
			</hgroup>
		</article>
	</section>
	<section class="bone" style="padding-top: 2rem;" id="zaim">
		<article class="sec_3">
			<h2>Как быстро получить займ?</h2>
			<hgroup>
				<div>
					<div><img src="img/img_3_1.png" /></div>
					<h3>Отправьте заявку</h3>
					<p>Вы оставляете заявку на сайте или звоните <wbr>нам по тел. 8 800 600 99 90</p>
				</div>
				<div>
					<div><img src="img/img_4_1.png" /></div>
					<h3>Дождитесь рассмотрения</h3>
					<p>Ваша заявка рассматривается нашей <wbr>системой</p>
				</div>
				<div>
					<div><img src="img/img_5_1.png" /></div>
					<h3>Не пропустите звонок</h3>
					<p>В случае одобрения Вам звонит <wbr>менеджер и договаривается об удобном <wbr>времени получения денег</p>
				</div>
				<div>
					<div><img src="img/img_6_1.png" /></div>
					<h3>Встретьтесь с агентом</h3>
					<p>Наш агент оформит все документы у Вас <wbr>дома</p>
				</div>
				<div>
					<div><img src="img/img_7_1.png" /></div>
					<h3>Получите деньги</h3>
					<p>В течение дня деньги поступят на Ваш <wbr>банковский счет</p>
				</div>
			</hgroup>
			<button class="dv_mobile" v-on:click="WsScrollTo('zform', $event)">Получить деньги</button>
		</article>
	</section>
	<section id="preim">
		<article class="sec_4">
			<h2>Наши преимущества</h2>
			<hgroup>
				<div>
					<div><img src="img/ico_3_user.svg" /></div>
					<h3>Только паспорт</h3>
					<p>Из документов необходим только паспорт РФ</p>
				</div>
				<div>
					<div><img src="img/ico_4_home.svg" /></div>
					<h3>Без кредитной истории</h3>
					<p>Мы не требуем кредитную историю</p>
				</div>
				<div>
					<div><img src="img/ico_5_check.svg" /></div>
					<h3>Нет штрафов</h3>
					<p>Полное отсутствие штрафов</p>
				</div>
				<div>
					<div><img src="img/ico_6_blank.svg" /></div>
					<h3>Приедем сами</h3>
					<p>Нет необходимости выходить из дома, мы сами приедем к Вам</p>
				</div>
				<div>
					<div><img src="img/ico_7_calendar.svg" /></div>
					<h3>Быстрый расчёт</h3>
					<p>Деньги на счет поступят в день обращения</p>
				</div>
				<div>
					<div><img src="img/ico_8_notepad.svg" /></div>
					<h3>Работаем честно</h3>
					<p>Возвратная сумма прописана в договоре и не меняется</p>
				</div>
			</hgroup>
		</article>
	</section>
	<section id="uslov">
		<article class="sec_5">
			<h2>Условия и документы</h2>
			<dl>
				<input type="radio" name="slid" id="slid_1" class="hidden" checked />
				<dt><label for="slid_1">Требования к заемщику</label></dt>
				<input type="radio" name="slid" id="slid_2" class="hidden" />
				<dt><label for="slid_2">Условия выдачи займа</label></dt>
				<input type="radio" name="slid" id="slid_3" class="hidden" />
				<dt><label for="slid_3">Способы погашения</label></dt>
				<input type="radio" name="slid" id="slid_4" class="hidden" />
				<dt class="last"><label for="slid_4">Свидетельства</label></dt>
				<dd class="slid_1">Получить микрозайм может любой гражданин РФ от 18 до 70 лет, который <br>проживает <a href="pdf/География присутствия.pdf">в зоне обслуживания</a> нашей компании. Необходимо наличие стабильного источника дохода, из документов нужен только паспорт.</dd>
				<dd class="slid_2">
					<h3>Мы полностью соблюдаем законодательство РФ. Со всеми документами вы можете ознакомиться заранее:</h3>
					<ul>
						<li><a target="_blank"
							href="https://finmoll.ru/backend/content/documents/rules_microloans">Правила предоставления микрозаймов</a></li>
						<li><a target="_blank" href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions">Общие условия договора микрозайма</a></li>
						<li><a target="_blank" href="https://finmoll.ru/backend/content/documents/microloan_providing_info">Информация об условиях предоставления, использования и возврата потребительского займа</a></li>
						<li><a target="_blank" href="/admd/pdf/informaciyaDlyaPoluchatelejFinansovojUslugi.pdf">Информация
							для получателей финансовой услуги</a></li>
					</ul>
				</dd>
				<dd class="slid_3">
					<h3>Платежи по договору займа можно внести любым из перечисленных способов:</h3>
					<p><span>ВАЖНО!</span> Номер договора займа должен содержать 8 знаков – 00123456 </p>
					<ol>
						<li>
							<b>В сети салонов связи и пунктах обслуживания сервиса «Золотая корона»:</b>
							<p>
								<img src="img/MTC_Logo_RGB.svg" style="width: 50px; height: 50px"/>
								<img src="img/image_18.png" />
							</p>
							<p>Для внесения платежа Вам потребуется паспорт, ФИО заемщика, номер договора займа. БИК 045004641; Идентификатор ФИНМОЛЛ 060421043.</p>
						</li>
						<li>
							<b>Оплатить через сеть терминалов «Элекснет» </b>
							<p>
								<img src="img/image_20.png" />
							</p>
						</li>
						<li>
							<b>В магазинах kari и kari KIDS:</b>
							<p>
								<img src="img/image_23.png" />
								<img src="img/image_24.png" />
							</p>
						</li>
						<li>
							<b>Оплатить банковской картой на сайте ООО МКК «ФИНМОЛЛ»</b>
							<p><a href="#">https://finmoll.com</a></p>
						</li>
            <li>
							<b>Оплатить в Личном кабинете клиента на сайте ООО МКК «ФИНМОЛЛ»</b>
						</li>
            <li>
							<b>Оплатить в мобильном приложении клиента «ФИНМОЛЛ КАБИНЕТ КЛИЕНТА»</b>
						</li>
            <li>
							<b>По банковским реквизитам ООО МКК «ФИНМОЛЛ»</b>
              <div id="sber">
                <img src="img/image_25.svg " style="width: 134px; height: 41px"/>
                <div>
                  <p><b>Комиссия:</b> устанавливается банком, в соответствии  с действующими тарифами</p>
                  <p><b>Зачисление:</b> от 3 до 5 банковских дней</p>
                  <ul style="list-style: square"><b>Необходимо:</b>
                    <li>Номер договора займа и ФИО заемщика</li>
                    <li>Реквизиты ООО МКК «ФИНМОЛЛ»</li>
                  </ul>
                </div>
              </div>
						</li>
					</ol>
					<p>Для перевода через Сбербанк России Вам необходимо указать реквизиты ООО МКК «ФИНМОЛЛ»</p>
					<dl>
						<dt>Получатель платежа:</dt>
						<dd>ООО МКК «ФИНМОЛЛ»</dd>
						<dt>Банк получателя:</dt>
						<dd>ПАО Сбербанк</dd>
						<dt>БИК:</dt>
						<dd>044525225</dd>
						<dt>ИНН:</dt>
						<dd>7705954143</dd>
						<dt>КПП:</dt>
						<dd>785250001</dd>
						<dt>ОГРН/ОГРНИП:</dt>
						<dd>1117746509638</dd>
						<dt>Кор. счет:</dt>
						<dd>30101810400000000225</dd>
						<dt>Расчетный счет:</dt>
						<dd>40701810738000002048</dd>
						<dt>Назначение платежа:</dt>
						<dd>Погашение займа по договору № ХХХХХХХХ (8 знаков), Иванов Иван</dd>
					</dl>
				</dd>
				<dd class="slid_4">
					<h3>Платежи по договору займа можно внести любым из перечисленных способов:</h3>
					<ul>
						<li><a target="_blank"
										href="https://finmoll.ru/backend/content/documents/certificate_ooo_finmoll">Свидетельство ООО МКК
							«ФИНМОЛЛ»</a></li>
						<li><a target="_blank" href="https://finmoll.ru/backend/content/documents/certificate_sro_mir">Свидетельство членства СРО МИР</a></li>
					</ul>
				</dd>
			</dl>
			<br style="clear: both;" />
		</article>
	</section>
	<footer>
		<section id="contact">
			<h2>Контакты</h2>
			<p>ООО МКК «ФИНМОЛЛ» Общество с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ»</p>
			<hgroup>
				<div>
					<div><img src="img/ico_1_mail_b.svg" /></div>
					<h3><a href="mailto:help@msk.finmoll.com">help@msk.finmoll.com</a></h3>
					<p>c 9:00 до 21:00, без выходных</p>
				</div>
				<div>
					<div><img src="img/ico_2_phone_b.svg" /></div>
					<h3><a href="tel:88006009990">8 800 600 99 90</a></h3>
					<p>звонок бесплатный по РФ</p>
				</div>
				<div>
					<div><img src="img/ico_9_geo.svg" /></div>
					<h3>Юридический адрес: 630112, Россия, <wbr>г. Новосибирск, ул. Фрунзе, д. 242, помещение 406</h3>
					<p>ОГРН:1117746509638</p>
				</div>
				<div>
					<button v-on:click="WsScrollTo('zform', $event)">Получить деньги</button>
				</div>
			</hgroup>

      <p>*ООО МКК «ФИНМОЛЛ»
Сумма по одному договру займа от 30000 до 100000 рублей.
Займы предоставляются на условиях платности, срочности и возвратности, сроком до 52 недель, процентные ставки по договорам займа составляют от 23,50% до 292,80% годовых в зависимости от вида займа и срока пользования денежными средствами, при этом диапазон значений полной стоимости займа (ПСК) составляет от 21,500% до 292,000% в соответствии с <a target="_blank" href="/admd/pdf/2024.04.02Information_about_the_conditions_for_providing microloans_print.pdf"><br>Информацией об условиях предоставления, использования и возврата потребительского микрозайма ООО МКК «ФИНМОЛЛ».</a>
Обязательные платные услуги отсутствуют. Ответственность за неисполнение или ненадлежащее исполнение обязательства (неустойка, пеня) отсутствует.<br>
Конкретные условия договора займа указываются в Индивидуальных условиях и согласуются сторонами до подписания Договора займа. Денежные средства на срок более 25 недель могут предоставляться на основании двух договоров займа, условия которых подлежат согласованию сторонами в Индивидуальных условиях по каждому из договоров в отдельности. ООО МКК «ФИНМОЛЛ» вправе отказать в предоставлении займа полностью или предложить иные условия заключения договора микрозайма до его фактического заключения.»<br>Требования к заемщикам: возраст от 18 до 70 лет. Гражданство РФ. Постоянная регистрация на территории РФ. Наличие контактного телефонного номера. ООО МКК «ФИНМОЛЛ». Регистрационный номер в государственном реестре МФО: 651403550005541. ОГРН 1117746509638. Юридический адрес: 630112, Новосибирская область, город Новосибирск, улица Фрунзе, дом 242, помещение 406.
</p>
      <p>
        **Данный калькулятор носить исключительно демонстрационный характер, представленные в калькуляторе расчеты являются информационными и могут не соответствовать согласованным условиям договора займа. Все условия договора займа подлежат согласованию при заключении договора займа в соответствии с <a target="_blank" href="/admd/pdf/2024.04.02Information_about_the_conditions_for_providing microloans_print.pdf">Информацией об условиях предоставления, использования и возврата потребительского микрозайма ООО МКК «ФИНМОЛЛ».</a>
      </p>
		</section>
		<section>
			<dl>
				<dt>© {{ year }} Все права защищены.</dt>
				<dd><a href="https://finmoll.ru/upload/iblock/37e/politika-v-otnoshenii-obrabotki-pd_finmoll_1_.pdf">Политика в отношении обработки персональных данных</a></dd>
				<br style="clear: both;" />
			</dl>
			<br style="clear: both;" />
		</section>
	</footer>
	</span>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
/* eslint-disable vue/no-unused-components */
export default {
	name: "abTest",
	data() {
		return {
      year: 0,
			isPostLoading   : false,
			PostLoading_cth : 0,
			isTest          : false,
			rangePercent    : 1,
			ConfirmationGUID: null,
			// self_url        : '',
			isDebug         : true,
			getLoanLimit    : 300,
			getLoanEnd      : 0,
			getLoanInterval : 30000,
			getLoanIndex    : 0,
      burgerMenu:false,
		}
	},
	components: {
		sorslid:() => import('@/components/form/rangeSlider' ),
		loader :() => import('@/components/abt/loader_box'   ),
		loaderd:() => import('@/components/abt/loader_answer'),
		block1 :() => import('@/components/abt/block/block1' ),
		block2 :() => import('@/components/abt/block/block2' ),
		block3 :() => import('@/components/abt/block/block3' ),
		block4 :() => import('@/components/abt/block/block4' ),
		block5 :() => import('@/components/abt/block/block5' ),
		block6 :() => import('@/components/abt/block/block6' ),
		block7 :() => import('@/components/abt/block/block7' ),
    banner :() => import('@/components/banner/goToLk.vue'),
    esia   :() => import('@/components/esia.vue')
	},
	computed:{
		rangeValue: {
			get() { return this.summVuex; },
			set(value) {
				let saveSumm = this.summVuex;
				this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: value});
				this.$store.dispatch('saveSendData'     , {target: 'CALC_SUMM' , value: value});
				if (this.FixedPay ==0 ) {
					this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: saveSumm});
					this.$store.dispatch('saveSendData'     , {target: 'CALC_SUMM' , value: saveSumm})
				}
			}
		},
		...mapState({
			ConfirmationCode: state => state.Form.sendData.SmsConfCode,
			systemFormVuex  : state => state.Form.system,
			maxBaseProduct  : state => state.Deal.maxBaseProduct,
			statusVuex      : state => state.Form.workData,
			valueVuex       : state => state.Form.sendData,
			rangeMin        : state => state.Deal.minBaseProduct.Amount,
			rangeMax        : state => state.Deal.MaxSumm,
			rangeStep       : state => state.Deal.StepSumm,
			summVuex        : state => state.Deal.SelectedSumm,
			abstractTime    : state => state.Deal.abstractTime,
			minBaseProduct  : state => state.Deal.minBaseProduct,
			maxPdlProduct   : state => state.Deal.maxPdlProduct,
			isLoading       : state => state.Form.system.loading,
			cookie          : state => state.Cookie.cookie.Partner_Id,
			loadnId         : state => state.Form.system.loadnId,
		}),
		...mapGetters([ 'FixedPay', 'paymentInfo', 'isAdressValid', 'isJobValid', 'getRedirectUrl' ]),
	},
	methods:{
    toggleBurgerMenu(){
      this.burgerMenu = !this.burgerMenu;
    },
		scrollernd:  function(){},
		getLoanTimeInterval(){
			if( this.getLoanIndex == 0 ) {
				return 30000
			} else if( this.getLoanIndex == 1 ) {
				return 20000
			} else if( this.getLoanIndex > 1 ) {
				return  5000
			}
		},
		getLoan(){
		// getLoanLimit
		// getLoanEnd
			// устанавливаем конечное время после которого не будет спрашиваться статус
			/*
			if(this.getLoanEnd == 0 ){
				this.getLoanEnd = (this.getLoanLimit*1000) + Number(new Date())
				if(this.isDebug){
					console.log( 'set getLoanEnd' )
					console.log( this.getLoanEnd )
				}
			} else {
				if(this.isDebug){
					console.log( 'report getLoanEnd' )
					console.log( this.getLoanEnd )
					console.log( Number(new Date() ) )
				}
			}
			*/
			this.isPostLoading = true
			this.getLoanIndex++
			// запускаем процесс
			//if( Number(new Date()) < this.getLoanEnd && this.getLoanIndex < 50 ){
			if( this.getLoanIndex < 50 ){
				if(this.isDebug){
					console.log( 'this.loadnId' )
					console.log( typeof this.loadnId )
					console.log( this.loadnId )
				}
				this.$myApi.SendRequest({
					action:'CheckDecisionByID',
					typeRequest:'loan',
					loandId:this.loadnId
				}).then((res)=>{
					if(this.isDebug){
						console.log('Rezult getResultLoan .....')
						console.log(res)
					}
					if ( typeof res == 'object' && res.onItsWay === 'true' ) {
						if (
							res.DealProductType == 'false'
							|| res.DealProductType == false
						) {
							console.log('CheckDecisionByID getRedirectUrl')
							this.isPostLoading = false
							// redirect
							if (window.canRedirect === 1) {
								this.$palantir.trackAction(128,window.linkToMarket);
								document.location.href = window.linkToMarket;
							} else {
								this.$store.dispatch('formRouting',7);
							}
						} else if (
							res.DealProductType == 'true'
							|| res.DealProductType == true
						) {
							console.log('CheckDecisionByID accssepted')
							this.isPostLoading = false;
              this.$store.dispatch('formRouting',6);

						} else {
							console.log('CheckDecisionByID error invalid data returned')
							console.log( JSON.stringify( res, null, "\t" ) )
							this.isPostLoading = false
							this.$store.dispatch('formRouting',6);
						}
					} else {
						if(this.isDebug){
							console.log('CheckDecisionByID onItsWay not true')
							console.log(JSON.stringify( res, null, "\t" ))
						}
            // if( Number( new Date() ) < this.getLoanEnd ){
            //   setTimeout( this.getLoan(), this.getLoanTimeInterval() )
            // } else { this.isPostLoading = false; this.$store.dispatch('formRouting',6); }
            if(res.OnlineDemandGUID !== undefined) {
              this.$router.push(`/reg?r=${res.OnlineDemandGUID}`);
            } else {
              setTimeout( this.getLoan, Number(this.getLoanTimeInterval()) );
            }

					}
				}).catch((er)=>{
					// '{RequestID: 6D31EF4F-295B-49C7-B00F-0F9E10161944, Response: Object, Error: Object}'
					if( this.isDebug ){
						console.log('agen cath CheckDecisionByID')
						console.log(er)
					}
					// если непонятный ответ с ошибкой
					if(
						typeof er.Response == 'object'
						&& typeof er.Response.ExecutionError == 'object'
						&& typeof er.Response.ExecutionError.ExecutionErrorCode != 'undefined'
						&& er.Response.ExecutionError.ExecutionErrorCode == 1
					){
						if(this.isDebug){
							console.log('CheckDecisionByID error code')
							console.log(JSON.stringify( er, null, "\t" ))
						}
						//if( Number( new Date() ) < this.getLoanEnd ){
							if(this.isDebug){console.debug('ln:565',this.getLoanTimeInterval())}
							setTimeout( this.getLoan, Number(this.getLoanTimeInterval()) )
						/*} else {
							this.isPostLoading = false;
							this.$store.dispatch('formRouting',6);
						}*/
					} else {
						if(this.isDebug){
							console.log('CheckDecisionByID catch invalid data returned')
							console.log(er)
						}
						this.PostLoading_cth++
						// если прошла ошибка попробовать ещё раз ( 4 перезапуска )
						//if( ( Number( new Date() ) < this.getLoanEnd ) && this.PostLoading_cth < 2 ){
						if( this.PostLoading_cth < 2 ){
							if(this.isDebug){console.debug('ln:579',this.getLoanTimeInterval())}
							setTimeout( this.getLoan, Number(this.getLoanTimeInterval()) )
						}
					}
					this.$palantir.trackAction( 144, JSON.stringify ( er ) );
				})
			} else {
				this.isPostLoading = false;
				this.$store.dispatch('formRouting',6);
			}
		},
		adressCheck: function(){
			let result = 0;
			return new Promise((resolve, reject) => {
				this.$palantir.trackAction(122,'');
				this.$myApi.SendRequest({
					action: 'GetAddressTerritory',
					Address: this.valueVuex.RESIDENTIAL_ADDRESS,
					RESIDENTIAL_ADDRESS_DADATA: this.valueVuex.RESIDENTIAL_ADDRESS_DADATA
				})
				// eslint-disable-next-line no-unused-vars
				.then((res)=>{
					if (window.ym) {
						// eslint-disable-next-line no-undef
						ym(51632228, 'reachGoal', ' admdAdressTrue');
					}
					if (window.ga){
						// eslint-disable-next-line no-undef
						ga('send', 'event', 'admdAdress', 'admdAdressTrue');
					}
					result = 1;
					this.$palantir.trackAction(123,'');
					resolve();
					// eslint-disable-next-line no-unused-vars
				}).catch((res) => {
					this.$palantir.trackAction(124,JSON.stringify(res));
					let ErrorResult = this.$myApi.parseError(res, 'fio adressCheck');
					if (ErrorResult.ExecutionErrorCode > 0) {
						this.$store.commit('saveScrMsg', 'К сожалению, на данный момент ваш населённый пункт не обслуживается, но наша компания быстро расширяется, возможно, скоро появимся и у вас,  ожидайте появления наружной рекламы');
						if (window.ym) {
							// eslint-disable-next-line no-undef
							ym(51632228, 'reachGoal', 'admdAdressFalse');
						}
						if (window.ga) {
							// eslint-disable-next-line no-undef
							ga('send', 'event', 'admdAdress', 'admdAdressFalse');
						}
						result = -1;
						try {
							if (res.Response.ExecutionError.ExecutionErrorCode > 0) {
								result = res.Response.ExecutionError.ExecutionErrorCode * (-1)
							}
						} catch (e) { result = -1; }
						reject();
					} else {
						//случилась некая херня неожиданная, продолжаем принимать заявку
						result = 0;
						this.$palantir.trackAction(125,'');
						resolve();
					}
				}).finally(() => { this.$myApi.singleRequest({action:'adressZoneLog', value: result}); });
			});
		},
		step1(){
			let arr = [
				'CALC_SUMM',
				'PHONE',
				'EMAIL',
				'RESIDENTIAL_ADDRESS',
				'SECOND_NAME',
				'LAST_NAME',
				'BIRTHDAY',
				'FIRST_NAME',
				'GENDER'
			];
			let checkAdress = this.isAdressValid('RESIDENTIAL_ADDRESS');
			let isFormFieldCorrect = true;
			if (checkAdress.length > 0) {

				this.$store.dispatch('fieldError', { target: 'RESIDENTIAL_ADDRESS', value: checkAdress });
				this.$palantir.trackAction(116, 'RESIDENTIAL_ADDRESS');
				isFormFieldCorrect =  false;
			}
			arr.forEach(item => {
				if (this.statusVuex[item].code != 0) {
					this.$palantir.trackAction(117,item);
					this.$store.dispatch('errorShow', { target: item, value: true, });
					isFormFieldCorrect = false;
				}
			});
			if(!isFormFieldCorrect){this.$store.dispatch('hideLoading'); return isFormFieldCorrect; }
			this.$palantir.trackAction(115,'');
			this.$myApi.singleRequest({
				action:'AddShortRequest',
				data:{
					'PHONE':this.valueVuex['PHONE'],
					'FIRST_NAME':this.valueVuex['FIRST_NAME'],
					'LAST_NAME':this.valueVuex['LAST_NAME'],
					'BIRTHDAY':this.valueVuex['BIRTHDAY'],
					'SECOND_NAME':this.valueVuex['SECOND_NAME'],
					'RESIDENTIAL_ADDRESS':this.valueVuex['RESIDENTIAL_ADDRESS'],
					'RESIDENTIAL_ADDRESS_DADATA':this.valueVuex['RESIDENTIAL_ADDRESS_DADATA'],
				},
			});

			this.isIssetActiveRequest()
			.then(this.adressCheck)
			.then(()=>{

			// this.adressCheck()
			// .then(()=>{
				this.$store.dispatch('formRouting',2);
				this.$store.dispatch('hideLoading');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'step1_completed'});

			}).catch(()=>{
				//что то пошло не так в проверках

					if (window.canRedirect === 1) {
						this.$palantir.trackAction(128,window.linkToMarket);
						document.location.href = window.linkToMarket;
					} else {
						this.$store.dispatch('formRouting',7);
					}

				this.$store.dispatch('hideLoading');
			});

		},
		step2(){
			let arr = [
				'PASSPORT_SERIES',
				'PASSPORT_NUMBER',
				'PASSPORT_DEP_CODE',
				'PASSPORT_DATE',
				'BIRTHDAY',
				'BIRTHPLACE',
				'REGISTRATION_ADDRESS',
				'RESIDENTIAL_ADDRESS',
				'PASSPORT_DEP',
			];
			//проверяем заполнения полей
			let isFormFieldCorrect = true;
			let checkAdress = this.isAdressValid('REGISTRATION_ADDRESS');
			if (checkAdress.length > 0) {
				this.$store.dispatch('fieldError', { target: 'REGISTRATION_ADDRESS', value: checkAdress });
				isFormFieldCorrect =  false;
				this.$palantir.trackAction(116,'REGISTRATION_ADDRESS');
			}
			checkAdress = this.isAdressValid('RESIDENTIAL_ADDRESS');
			if (checkAdress.length > 0) {
				this.$store.dispatch('fieldError', { target: 'RESIDENTIAL_ADDRESS', value: checkAdress });
				isFormFieldCorrect =  false;
				this.$palantir.trackAction(116,'RESIDENTIAL_ADDRESS');
			}
			arr.forEach(item => {
				if (this.statusVuex[item].code != 0) {
					this.$palantir.trackAction(117,item);
					this.$store.dispatch('errorShow', { target: item, value: true, });
					isFormFieldCorrect = false;
				}
			});
			if(!isFormFieldCorrect){
        this.$store.dispatch('hideLoading');
        return isFormFieldCorrect;
      }
			this.$palantir.trackAction(129, '');
			try {
				let calcAge = new Date(new Date() - new Date(this.valueVuex['BIRTHDAY'])).getFullYear() - 1970;
				if (calcAge <= 21) {
					this.$palantir.trackAction(149,this.valueVuex['BIRTHDAY'] + ' calc =' + calcAge );
					if (window.canRedirect === 1) {
						this.$palantir.trackAction(128,window.linkToMarket);
						document.location.href = window.linkToMarket;
					} else {
						this.$store.dispatch('formRouting',7);
					}
					return false;
				}
				// eslint-disable-next-line no-empty
			} catch (e) { }
			//this.chekRegistrationAdress().then(this.adressCheck).then(()=>{ this.$store.dispatch('formRouting', 3); }).catch(()=>{
			this.adressCheck().then(()=>{
        this.$store.dispatch('formRouting', 3);
        this.WsScrollTo('zform');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'step2_completed'});

      }).catch(()=>{
					if (window.canRedirect === 1) {
						this.$palantir.trackAction(128, window.linkToMarket);
						document.location.href = window.linkToMarket;
					} else {
						this.$store.dispatch('formRouting',7);
					}
			}).finally(()=>{
				this.$store.dispatch('hideLoading');
			});
			// return isFormFieldCorrect;
		},
		step3(){
			// this.$palantir.trackAction(133,this.getRedirectUrl);
			let arr = [
				'WORK_JOB',
				'EXPER_RADIO',
				'CONST_INCOME',
				// 'OTHER_SOURCES_OF_INCOME',
				// 'CREDHISTORY_RADIO',
				// 'MEETING_DATE',
				// 'MEETING_HOUR',
				'EDUCATION',
				'MARITAL_STATUS',
				'MINOR_CHILDREN',
				'SOURCE_OF_INCOME',
				'PURPOSE_OF_THE_LOAN',
				// 'FINANCIAL_POSITION',
			];
      let Today = new Date();
      let date = new Date(Today.getTime() + 1000 * 60 * 60 * 24);
      let day = date.getDate();
      let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
      day = day < 10 ? '0' + day : day;
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();


      this.$store.dispatch('saveSendData',{
        target:'MEETING_DATE',
        value: date.getFullYear() + '-' + month + '-' + day
      });
      this.$store.dispatch('saveSendData',{
        target:'MEETING_HOUR',
        value: h + ':' + m
      });

      let checkJob = this.isJobValid('WORK_JOB');
      let isFormFieldCorrect = true;
      if (checkJob.length > 0) {

        this.$store.dispatch('fieldError', { target: 'WORK_JOB', value: checkJob });
        this.$palantir.trackAction(116, 'WORK_JOB');
        isFormFieldCorrect =  false;
      }
			// проверяем заполнения полей
			arr.forEach(item => {
				if (this.statusVuex[item].code != 0) {
					this.$palantir.trackAction(117,item);
					this.$store.dispatch('errorShow', { target: item, value: true, });
					isFormFieldCorrect = false;
				}
			});
			if(!isFormFieldCorrect){this.$store.dispatch('hideLoading'); return isFormFieldCorrect; }
			this.$store.dispatch('formRouting', 4);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'event': 'step3_completed'});
		},
		step4(){
			let arr = [ 'SmsConfCode', 'ASP' ];
			// проверяем заполнения полей
			// иноме
			//
			let isFormFieldCorrect = true;
			if(this.isDebug){console.log('SmsConfCode')}
			arr.forEach(item => {
				if (this.statusVuex[item].code != 0) {
					this.$palantir.trackAction(117,item);
					this.$store.dispatch('errorShow', { target: item, value: true, });
					isFormFieldCorrect = false;
				}
			});
			if(!this.isTest&&!isFormFieldCorrect){this.$store.dispatch('hideLoading'); return isFormFieldCorrect; }
			this.$palantir.trackAction(137, this.ConfirmationCode);
			if(this.isTest){
				this.$store.dispatch('hideLoading');
				this.isPostLoading = true
				setTimeout( ( ) => { this.isPostLoading = false } , 5000 )
				return true
			} else {
				if(this.isDebug){console.log('SendRequest')}
				this.$myApi.SendRequest({
					action: 'SMSConfirmationCodeCheck',
					ConfirmationGUID: localStorage.getItem('ConfirmationGUID'),
					ConfirmationCode: this.ConfirmationCode,
				}).then( res => {
					if(this.isDebug){
						console.log('SMSConfirmationCodeCheck');
						console.log(res);
					}
					if (res.CheckResult == true) {
						this.$palantir.trackAction(138,'');
						this.logSmsConfCode(1);
						this.sendData();
						console.log('sendingData')
						this.$store.dispatch('hideLoading')
						//this.$store.dispatch('saveSystemData', 'pdlThanks')
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'event': 'step4_completed'});
					} else {
						this.$palantir.trackAction(139,'');
						this.logSmsConfCode(-1);
						this.$store.commit('saveWorkData',{
							target:'SmsConfCode',
							status:{
								code:1,
								msg:'Некорректный	код'
							}
						});
					}
					this.$store.dispatch('hideLoading');
				}).catch((res) => {
					console.log('Error',res)
					this.$palantir.trackAction(140,JSON.stringify(res));
					let ErrorResult = this.$myApi.parseError(res, 'SMSConfirmationCodeCheck');
					this.logSmsConfCode(-2);
					if (ErrorResult.ExecutionErrorCode > 0) { alert('ошибка сервиса, попробуйте пожалуйста позже') }
					this.$store.dispatch('hideLoading');
				});
			}
			return isFormFieldCorrect;
		},
		insertPixel(src,tagg) {
			let pixel = document.createElement(tagg);
			pixel.src = src;
			if (tagg === 'img') {
				pixel.setAttribute('style','position:absolute;width:1px;height:1px;opacity:0;top:0;left:-100px;');
				let targetInsert = document.getElementById("app");
				document.body.insertBefore(pixel, targetInsert);
			} else if(tagg === 'script') {
				document.getElementsByTagName('head')[0].appendChild(pixel);
			}
		},
		sendData() {
			this.$palantir.trackAction(141,'');
			//this.$store.dispatch('showLoading');
			let preSendData	= Object.assign( {}, this.valueVuex );
      console.log('preSendData',preSendData)
			if (preSendData.CALC_SUMM < this.minBaseProduct.Amount) {
				//magic number, не трогай блиятть
        //потрогал, так как если в калькуляторе не трогали сумму, по умолчанию не присваивалась в this.valueVuex.CALC_SUMM
				preSendData.CALC_SUMM = this.minBaseProduct.Amount;
			}
			if (preSendData.CALC_SUMM > this.maxBaseProduct.Amount) {
				preSendData.CALC_SUMM = this.maxBaseProduct.Amount;
			}
      console.log('preSendData',preSendData)
			this.$myApi.singleRequest({ action:'SendRequest', data:preSendData }).then((res) => {
				console.log('SendRequest rezult')
				console.log(JSON.stringify(res, null, '\t' ))
				this.$palantir.trackAction( 142, JSON.stringify( res ) );
				if ( res.pixel != undefined ) { this.insertPixel( res.pixel,res.tagg ); }
				if(
					(
					typeof res == 'object'
					&& typeof res.result == 'string'
					&& res.result == 'ok'
					&& typeof res.loadnId == 'number'
					)
				){
					this.$store.commit('saveSystemData',{ target:'loadnId', value:res.loadnId });
					if(this.isDebug){console.log('getResultLoan')}
					if(this.isDebug){console.debug('ln:901',this.getLoanTimeInterval())}
					this.isPostLoading = true
					setTimeout( this.getLoan, Number(this.getLoanTimeInterval()) )
				} else {
					console.log('SendRequest Error')
					console.log(JSON.stringify(res, null, '\t' ))
				}
				if (window.ym) {
					// eslint-disable-next-line no-undef
					ym(51632228, 'reachGoal', 'allRequest');
				}
				if (window.VK) {
					// eslint-disable-next-line no-undef
					VK.Goal('lead');
				}
				this.$store.dispatch('formRouting', 5);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'step5_completed'});
			}).catch((res) => {
				this.$palantir.trackAction(143,JSON.stringify(res))
				console.log('sendData error')
				console.log(res)
			});
		},
		logSmsConfCode(result){ this.$myApi.singleRequest({ action:'logSmsConfCode', result:result }).then(res=>console.log(res)).catch(res=>console.log('catch', res)); },
		chekRegistrationAdress: function () {
			return new Promise((resolve, reject) => {
				this.$palantir.trackAction(130,'');
				this.$myApi.SendRequest({
					action: 'chekRegistrationAdress',
					REGISTRATION_ADDRESS_DADATA: this.valueVuex.REGISTRATION_ADDRESS_DADATA,
					FIRST_NAME: this.valueVuex.FIRST_NAME,
					LAST_NAME: this.valueVuex.LAST_NAME,
					SECOND_NAME: this.valueVuex.SECOND_NAME,
					PASSPORT_SERIES: this.valueVuex.PASSPORT_SERIES,
					PASSPORT_NUMBER: this.valueVuex.PASSPORT_NUMBER,
					BIRTHDAY: this.valueVuex.BIRTHDAY,
					PHONE:this.valueVuex.PHONE
					// eslint-disable-next-line no-unused-vars
				}).then((res) => {
					this.$palantir.trackAction(131,'');
					this.$myApi.singleRequest({ action: 'checkLog', value: 0 });
					resolve();
				}).catch((res) => {
					this.$palantir.trackAction(132,JSON.stringify(res));
					let ErrorResult = this.$myApi.parseError(res, 'passport chekRegistrationAdress');
					if (ErrorResult.ExecutionErrorCode > 0) {
						if (window.ym) {
							// eslint-disable-next-line no-undef
							ym(51632228, 'reachGoal', 'admdScoringFail');
						}
						this.$store.commit('saveScrMsg', 'К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.');
						this.$myApi.singleRequest({ action: 'checkLog', value: res.Response.ExecutionError.ExecutionErrorMessage });
						reject();
					} else {
						//случилась некая херня неожиданная, продолжаем принимать заявку
						resolve();
					}
				});
			})
		},
		isIssetActiveRequest(){
			return new Promise((resolve, reject) => {
				this.$palantir.trackAction(118,'');
				this.$myApi.SendRequest({
					action: 'isIssetActiveRequest',
					data: {
						FIRST_NAME: this.valueVuex.FIRST_NAME,
						LAST_NAME: this.valueVuex.LAST_NAME,
						SECOND_NAME: this.valueVuex.SECOND_NAME,
						PHONE: this.valueVuex.PHONE
					},
					// eslint-disable-next-line no-unused-vars
				}).then(res=>{
					this.$palantir.trackAction(119,'');
					this.$myApi.singleRequest({ action: 'checkfioLog', value: 0 });
					resolve();
				}).catch(res=>{
					this.$palantir.trackAction(120,JSON.stringify(res));
					let ErrorResult = this.$myApi.parseError(res, 'fio isIssetActiveRequest');
					if (ErrorResult.ExecutionErrorCode > 0) {
						this.$store.commit('saveScrMsg', 'К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.');
						if (window.ym) {
							// eslint-disable-next-line no-undef
							ym(51632228, 'reachGoal', 'admdScoringFail');
						}
						this.$myApi.singleRequest({ action: 'checkfioLog', value: ErrorResult.ExecutionErrorMessage });
						reject();
					} else {
						this.$palantir.trackAction(121,JSON.stringify(res));
						//случилась некая херня неожиданная, продолжаем принимать заявку
						resolve();
					}
				});
			});
		},
		nextBlock:function (ev) {
			switch(this.systemFormVuex.currentFormScreen){
				case 1:
					this.$store.dispatch('showLoading');
					if(this.isTest){
						this.step1()
						this.$store.dispatch('formRouting', 2)
						this.WsScrollTo('zform', ev)
					} else {
						if (this.step1()) { this.$store.dispatch('formRouting', 2); }
						this.WsScrollTo('zform', ev)
					}
					break;
				case 2:
					this.$store.dispatch('showLoading');
					// if(this.isTest){
					// 	this.step2()
					// 	this.$store.dispatch('formRouting', 3)
					// 	this.WsScrollTo('zform', ev)
					// } else {
					// 	// if (this.step2()) { this.$store.dispatch('formRouting', 3); }
					// 	this.step2();
					// 	this.WsScrollTo('zform', ev)
					// }
            this.step2();
					break;
				case 3:
					this.$store.dispatch('showLoading');
					if(this.isTest){
						this.step3()
						this.$store.dispatch('formRouting', 4)
						this.WsScrollTo('zform', ev)
					} else {
						if (this.step3()) { this.$store.dispatch('formRouting', 4); }
						this.WsScrollTo('zform', ev)
					}
					break;
				case 4:
					this.$store.dispatch('showLoading');
					if(this.isTest){
						this.step4()
						this.$store.dispatch('formRouting', 5)
						this.systemFormVuex.currentFormScreen = 'pdlThanks'
						this.WsScrollTo('zform', ev)
					} else {
						this.step4()
					}
					break;
				case 5:
					if(this.isTest){
						this.WsScrollTo('zform', ev)
					} else {
						this.WsScrollTo('zform', ev)
					}
					break;
				default:break;
			}
		},

		WsScrollTo: function (wel, ev=false) {
      //что бы при скроле по якорной ссылке, скрывать выпадающее меню
      if(this.burgerMenu) {
        this.burgerMenu = false;
      }
			window.scrollTo({
				left:0,
				top:document.getElementById(wel).offsetTop,
				behavior: 'smooth'
			});
			if (ev) { ev.preventDefault()}
		},
    saveDadataAddress(refs, value) {
      let result = undefined;
      this.$myApi.suggestResult(refs,{ 'value': value, 'type': refs }).then((res)=>{
        if(res.data.result.suggestions.length > 0) {
          result = res.data.result.suggestions[0];
          console.log(result)
          this.$store.dispatch('saveSendData', {
            target: refs + '_DADATA',
            value: result,
          });
        }
      }).catch((res)=>{
        console.log(res);
      }).finally(()=>{
        this.$store.dispatch('saveSendData', {
          target: refs,
          value: result !== undefined ? result.value : value
        });
      });
    },
    getFromNsk(){

      const nskAlias = [
        {nsk:'lastName', msk:'LAST_NAME'},
        {nsk:'firstName', msk:'FIRST_NAME'},
        {nsk:'middleName', msk:'SECOND_NAME'},
        {nsk:'phone', msk:'PHONE'},
        {nsk:'email', msk:'EMAIL'},
        {nsk:'passportSerie', msk:'PASSPORT_SERIES'},
        {nsk:'passportNumber', msk:'PASSPORT_NUMBER'},
        {nsk:'passportIssueDate', msk:'PASSPORT_DATE'},
        {nsk:'birthPlace', msk:'BIRTHPLACE'},
        {nsk:'orgName', msk:'WORK_JOB'},
        {nsk:'orgPosition', msk:'WORK_TITLE'},
        {nsk:'address', msk:'REGISTRATION_ADDRESS'},
        {nsk:'birthDate', msk:'BIRTHDAY'},
        {nsk:'passportIssuerCode', msk:'PASSPORT_DEP_CODE'},
        {nsk:'passportIssuer', msk:'PASSPORT_DEP'},

      ];

      try {
        if(this.$route.query.subid !== undefined) {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_API_MS + '/getNskData.php',
            data: {
              session_id:this.$myApi.sessionId(),
              guid:this.$route.query.subid
            }
          }).then((res)=>{
            const workData = res?.data?.result?.client;
            if(workData && Object.keys(workData).length > 0 && workData.constructor === Object) {
              nskAlias.forEach((item)=>{
                if(workData[item.nsk] !== undefined && workData[item.nsk] != null){
                  if(item.nsk === 'address') {
                    console.log('address')
                    this.saveDadataAddress(item.msk,workData[item.nsk])
                  } else {
                    this.$store.dispatch('saveSendData',{
                      target:item.msk,
                      value:workData[item.nsk]
                    });
                  }
                }
              });
            }



          }).catch((res)=>{
            console.log(res)
          }).finally(()=>{
            // setTimeout(()=>{
              this.WsScrollTo('zform');
            // },500)
            if(this.$route.query.sub1 && parseInt(this.$route.query.sub1,10) > 0 && this.$route.query.sub1 % 1000 === 0){
              const addCalcSumm = parseInt(this.$route.query.sub1,10);
              if (addCalcSumm >= this.minBaseProduct.Amount && addCalcSumm <= this.maxBaseProduct.Amount) {
                this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: addCalcSumm});
                this.$store.dispatch('saveSendData',{
                  target:'CALC_SUMM',
                  value:addCalcSumm
                })
              }
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
	},
	mounted() {
    let t = new Date()
    this.year = t.getFullYear()

    localStorage.setItem('instWay','1');

		if (window.ym) {
      // eslint-disable-next-line no-undef
      ym(51632228, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true,
        // userParams: {
        //   // session_id: session_id,
        //   // partner_id: partner_id,
        // }
      });
			// eslint-disable-next-line no-undef
			ym(51632228, 'reachGoal', 'allEnter');
			// eslint-disable-next-line no-undef
			ym(51632228, 'reachGoal', 'lendNotAdmd');
		}
		this.$store.dispatch('formRouting', 1);
		this.$store.dispatch('getDiealInfo');
		// this.self_url = (new URL( location.href )).pathname;
		// this.$palantir.markAbTest();


    try {

      if(this.$route.query.Partner_Id !== undefined) {
        switch (parseInt(this.$route.query.Partner_Id,10)){
          case 10004:
            this.getFromNsk();
            break;
          case 10006:
            this.getFromNsk();
            break;
        }
      }
    } catch (e) {
      console.log(e)
    }
		this.$store.dispatch('readCookie');
	},
    watch:{
		abstractTime(val){
			let self = this;
			if (val == 1) {
				if (this.summVuex >= this.minBaseProduct.Amount) {
					this.animation = true;
					console.log('1')
					setTimeout(()=>{ self.animation = false; },350);
					this.rangeValue = this.maxPdlProduct.Amount;
				}
			} else {
				if (this.summVuex < this.minBaseProduct.Amount) {
					this.animation = true;
					this.rangeValue = this.minBaseProduct.Amount;
					setTimeout(()=>{ self.animation = false; },350);
				}
			}
		},
		summVuex(val){
			if (val <  this.minBaseProduct.Amount) { this.rangePercent = 3; }
			if (val >= this.minBaseProduct.Amount && val < this.maxBaseProduct.Amount) { this.rangePercent = 1; }
			if (val >  this.maxBaseProduct.Amount) { this.rangePercent = 2; }
		}
    }
}
</script>
<style scope>
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: bolder;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-B.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: italic;
  font-weight: bolder;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-BI.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: normal;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-C.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: lighter;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-L.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: italic;
  font-weight: lighter;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-LI.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: bold;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-M.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: italic;
  font-weight: bold;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-MI.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 500;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-R.ttf')  format('truetype');
}
@font-face {
  font-family: 'Ubuntu';
  font-style: italic;
  font-weight: 500;
  src: url('../../public/font/ubuntu-font-family/Ubuntu-RI.ttf')  format('truetype');
}
@media (max-width: 768px) {
	.dv_mobile { display: unset; }
	.dv_mobile-dv_tablet { display: unset; }
	.dv_mobile-dv_desktop { display: unset; }
	.dv_mobile-dv_fullscreen { display: unset; }
	.dv_tablet { display: none; }
	.dv_tablet-dv_desktop { display: none; }
	.dv_tablet-dv_fullscreen { display: none; }
	.dv_desktop { display: none; }
	.dv_desktop-dv_fullscreen { display: none; }
	.dv_fullscreen { display: none; }
}
@media (min-width: 768px) and (max-width: 992px) {
	.dv_mobile { display: none; }
	.dv_mobile-dv_tablet { display: unset; }
	.dv_mobile-dv_desktop { display: unset; }
	.dv_mobile-dv_fullscreen { display: unset; }
	.dv_tablet { display: unset; }
	.dv_tablet-dv_desktop { display: unset; }
	.dv_tablet-dv_fullscreen { display: unset; }
	.dv_desktop { display: none; }
	.dv_desktop-dv_fullscreen { display: none; }
	.dv_fullscreen { display: none; }
}
@media (min-width: 992px) and (max-width: 1200px) {
	.dv_mobile { display: none; }
	.dv_mobile-dv_tablet { display: unset; }
	.dv_mobile-dv_desktop { display: unset; }
	.dv_mobile-dv_fullscreen { display: unset; }
	.dv_tablet { display: none; }
	.dv_tablet-dv_desktop { display: unset; }
	.dv_tablet-dv_fullscreen { display: unset; }
	.dv_desktop { display: unset; }
	.dv_desktop-dv_fullscreen { display: unset; }
	.dv_fullscreen { display: none; }
}
@media (min-width: 1200px) {
	.dv_mobile { display: none; }
	.dv_mobile-dv_tablet { display: none; }
	.dv_mobile-dv_desktop { display: none; }
	.dv_mobile-dv_fullscreen { display: unset; }
	.dv_tablet { display: none; }
	.dv_tablet-dv_desktop { display: none; }
	.dv_tablet-dv_fullscreen { display: unset; }
	.dv_desktop { display: none; }
	.dv_desktop-dv_fullscreen { display: unset; }
	.dv_fullscreen { display: unset; }
}

* { margin: 0; padding: 0; }
html, body { margin: 0; padding: 0; font-family: 'Ubuntu'; font-weight: 500; }
.hidden { visibility: hidden; display: none; }
.pa { float: left; }
.pb { float: right; }
button {
	width: 100%;
	background: #45B537;
	color: white;
	border: unset;
	text-transform: uppercase;
	font-weight: bold;
	height: unset;
}
.subtext2406{clear: both}
button > a { text-decoration: none; color: white; }
input[type=text]{ display: block; width: 100%; box-sizing: border-box; }
section.bone{ background-color: #F3F4F6; }
header { background: #F3F4F6; }
header > section{ margin: auto; display: flex; align-items: center; font-size: 1rem; padding-top: .7rem; justify-content: space-between; }
header > section > nav > menu{ list-style-type: none; display: flex; align-items: center; }
header > section > nav > menu > li{ white-space: nowrap; display: inline-block; padding: .1rem .2rem; }
header > section > nav > menu > li > a { text-decoration: none; color: #131515b3; font-size: .83rem; }
header > section > nav > menu > li > a.action { color: #131515; font-weight: 700; }
header > section > hgroup { display: flex; align-items: flex-start; font-size: .8rem; }
header > section > hgroup > img { margin: .2rem .5rem; }
header > section > hgroup > div { float: right; }
header > section > hgroup > div > b { white-space: nowrap; display: block; }
header > section > hgroup > div > b > a { color: #222721; text-decoration: none; }
header > section > hgroup > div > span { white-space: nowrap; font-size: .7rem; font-weight: 500; }
header + section > article { position: relative; background-image: unset; }
header + section > article > div { box-sizing: border-box; }
header + section > article > div > h2 { }
header + section > article > div > p { color: #131515b3;  }
header + section > article > div > span { color: #131515b3; display: block; }
header + section > article > div > span > b {  }
header + section > article > div > span > b > span {  }

/*section.banner .pcOnly { display: none }*/
/*section.banner .mobileOnly { }*/
/*section.banner { background-image: url(../../public/img/fin-moll_banner.svg); background-size: cover; color: #FFFFFF; margin-top: 2rem; padding: 0 0.7rem; position: relative }*/
/*section.banner>article { padding-bottom: 0.6rem; padding-top: 0.9rem }*/
/*section.banner p>span { background-color: #ABE600; color: #0f5740; font-weight: bold }*/
/*section.banner p:first-child { font-size: 0.6rem; font-weight: bold; margin-bottom: 0.5rem; line-height: 140% }*/
/*section.banner p:nth-child(2) { font-size: 0.5rem; margin-bottom: 0.8rem }*/
/*section.banner div { margin-bottom: 1rem; cursor: pointer; float: none; width: auto; padding: 0 }*/
/*section.banner p:nth-child(4) { font-size: 0.2rem }*/
/*section.banner svg { width: 4.6rem }*/
/*section.banner .phone { position: absolute; top: 3.4rem; right: 1.3rem;pointer-events: none }*/
/*section.banner .phone>img { width: 6.7rem }*/
/*section.banner a{color:inherit}*/

section { padding: unset; }
section > article { margin: auto; box-sizing: border-box; }
section > article > div { box-sizing: border-box; }
section > article > div > h2 { font-style: normal; font-weight: 700; color: #131515; }
section > article > div > label { color: #131515b3; display: flex; align-items: center; }
section > article > div > label > input[type=radio] {
	border: .1rem solid #D5D5D5;
	appearance: none;
	margin-left: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-around;
	font-size: .8rem;
}
section > article > div > label > input[type=radio]:checked { border: .1rem solid #262323; }
section > article > div > label > input[value=M]::before {content: 'М';}
section > article > div > label > input[value=F]::before {content: 'Ж';}
input[value=F]::before {content: 'Ж';}
section > article > article {
	width: 25rem;
	box-sizing: border-box;
	background-color: white;
	padding: 3rem 2.5rem;
	box-shadow: 0 0.2rem 1rem #0000001a;
	border-radius: 1rem;
	float: right;
	margin-bottom: 5rem;
	min-height: 30rem;
}
section > article > article > h3 { text-align: center; }
section > article > article > h3 + div > p { color: #131515b3; text-align: center; text-transform: lowercase; }
section > article > article > h3 + div > p > b { color: #131515; font-weight: bold; }
section > article > article > h3 + div > input, section > article > article > h3 + div > .slider { width: 100%; }
section > article > article > h2 {  }
section > article > article > dl {  }
section > article > article > dl > dt { float: left; color: #131515b3; clear: both; }
section > article > article > dl > dd { float: right; color: #45B537; font-weight: bold; text-transform: lowercase; }
section > article > article > dl + button { clear: both; }
section > article > article > dl + button > a{ text-decoration: none; color: white; }
section > article > hgroup { flex-wrap: wrap; clear: both; margin: auto; }
section > article > hgroup > div { display: flex; align-items: center; color: #13151580; padding-bottom: 1rem; }
section > article > hgroup > div > img, section > article > hgroup > div input[type=checkbox] {margin-right: .5rem;}
footer { background: #131515; color:#FFFFFF; }
footer a{color:inherit}
.sec_2 > hgroup > div > p { white-space: nowrap; color: #131515b3; }
.sec_2 > hgroup > div h1 { color: #131515; }
.sec_2 > hgroup > div h3 { color: #131515; }
.sec_2 > hgroup > div a { color: #43AC34; }
.sec_2 > hgroup > div > button { }
.sec_2 > hgroup > div > img { margin-left: 0.2rem; margin-right: 0.7rem; }
.sec_2 > hgroup > div input[type=checkbox] { background: #F5F5F5; appearance: none; position: relative; }
.sec_2 > hgroup > div input[type=checkbox]::before {
	content: '';
	display: none;
	appearance: none;
	position: absolute;
	top: .1rem;
	border-radius: 0;
	transform: rotate(45deg);
	border-right: .1rem solid #0D5740;
	border-bottom: .1rem solid #0D5740;
}
.sec_2 > hgroup > div input[type=checkbox]:checked::before{display: block;}
.sec_3 { background-repeat: no-repeat; }
.sec_3 > hgroup { margin: 0; }
.sec_3 > hgroup > div { display: block; box-sizing: border-box;  }
.sec_3 > hgroup > div > div {  }
.sec_3 > hgroup > div > div > img {  }
.sec_3 > hgroup > div > h3 {  }
.sec_3 > hgroup > div > p {  }
.sec_4 {  }
.sec_4 > h2 { padding-bottom: 2rem; }
.sec_4 > hgroup { width: 100%; justify-content: center; }
.sec_4 > hgroup > div { display: block; }
.sec_4 > hgroup > div > div {  }
.sec_4 > hgroup > div > div > img {  }
.sec_4 > hgroup > div > h3 {  }
.sec_4 > hgroup > div > p {  }
.sec_5 {  }
.sec_5 > h2 { padding-bottom: 2rem; }
.sec_5 > dl { position: relative; }
.sec_5 > dl > dt {
	width: 22rem;
	height: 3.5rem;
	border: .1rem solid #E4E4E4;
	border-bottom: none;
	align-items: center;
	justify-content: center;
}
.sec_5 > dl > input:first-child + dt { border-radius: .5rem .5rem 0 0; }
.sec_5 > dl > dt:nth-last-child(3) { border-radius: 0 0 .5rem .5rem; border-bottom: .1rem solid #E4E4E4; }
.sec_5 > dl > dt.last {  }
.sec_5 > dl > input:checked + dt { color: #43AC34; font-weight: 700; background: #E7F3E5; }
.sec_5 > dl > dd { display: none;  box-sizing: border-box; color: #131515b3; line-height: 150%;}
.sec_5 > dl > input#slid_1:checked ~ .slid_1, .sec_5 > dl > input#slid_2:checked ~ .slid_2, .sec_5 > dl > input#slid_3:checked ~ .slid_3, .sec_5 > dl > input#slid_4:checked ~ .slid_4 { display: block; }
.sec_5 > dl > dd > ul { display: flex; flex-wrap: wrap; }
.sec_5 > dl > dd > ul > li { box-sizing: border-box; position: relative; display: block; }
.sec_5 > dl > dd > ul > li::before {
	content: "";
	display: block;
	position: absolute;
	top: .6rem;
	background-image: url(../../public/img/ico_9_pdf.svg);
	background-repeat: no-repeat;
	background-size: 1.5rem;
}
.sec_5 > dl > dd > ul > li > a { color: #131515b3; }
.sec_5 > dl > dd > h3 { color: #131515; }
.sec_5 > dl > dd > p { padding-top: .5rem; padding-bottom: .5rem; }
.sec_5 > dl > dd > p > span { color: #0D5740; font-weight: bold; font-size: .9rem; }
.sec_5 > dl > dd > ol { counter-reset: for-num-counter; list-style: none; }
.sec_5 > dl > dd > ol > li { counter-increment: for-num-counter; position: relative; }
.sec_5 > dl > dd > ol > li > b { color: #131515; display: inline; line-height: 2rem; }
.sec_5 > dl > dd > ol > li::before {
	content: counter(for-num-counter);
	display: inline-block;
	background: #45B537;
	border-radius: 1rem;
	color: white;
	padding-right: 0rem;
}
.sec_5 > dl > dd > ol > li a {color: #131515b3;}
.sec_5 > dl > dd dl { display: flex; flex-wrap: wrap; }
.sec_5 > dl > dd dl > dt { width: 20%; color: #131515; font-weight: bold; padding-top: .8rem; }
.sec_5 > dl > dd dl > dd { width: 80%; padding-top: .8rem; }
.sec_5 > dl > dd > dl > dt { width: 35%; padding-top: .1rem; }
.sec_5 > dl > dd > dl > dd { width: 65%; padding-top: .1rem; }
.sec_5 > dl > dd > ol > li > dl > dd > ul { padding-left: 1.4rem; }
.sec_5 > dl > dd > ol > li > dl > dd > ul > li { list-style: unset; }
.sec_5 > dl > dd img { margin: 0.6rem; }
footer > section { margin: auto; }
footer > section > h2 { }
footer > section p { color: #ffffff80; }
footer > section > hgroup { display: flex; }
footer > section > hgroup img {  }
footer > section > hgroup > div {  }
footer > section > hgroup > div > h3 { white-space: nowrap; }
footer > section > hgroup > div > h3 > a { color: #FFFFFF; text-decoration: none; }
footer > section > hgroup > div > p { white-space: nowrap; }
footer > section > hgroup button { font-weight: bold; }
footer > section > hgroup button a { text-decoration: none; color: white; }
footer > section + section { padding-top: .8rem; border-top: 1px solid #ffffff1a; margin-top: 1rem; width: 100%; color: #ffffff66; }
footer > section + section > dl { margin: auto;}
footer > section + section > dl > dt {  }
footer > section + section > dl > dd {  }
footer > section + section > dl > dd a { color: #ffffff80; }

@media (max-width: 768px) {
  /*.subtext2406{font-size: .5rem;margin: 1rem 0 0}*/
  #sber { display: flex }
  #sber > div > ul > li { list-style: square }
	header > section > input[type=checkbox]{  }
	header > section > nav {
		display: block;
		position: absolute;
		background-color: white;
		border: 1px solid #000;
		top: 0;
		left: 0;
		z-index: 10;
		padding: 2rem .5rem 1rem .5rem;
	}
  header > section > nav.active{display: block}
	header > section > nav > menu { flex-direction: column; align-items: flex-start; }
}
	html, body { font-size: 7vw;}
	.pa { padding-left: 1rem; font-size: .52rem; }
	.pb { padding-right: 1rem; margin-bottom: 1rem; font-size: .52rem; }
	button { border-radius: .6rem; padding: .6rem; font-size: .5rem; }
	input[type=text]{ border: .06rem solid #D5D5D5; padding: .4rem .6rem; margin: .7rem 0; font-size: .5rem; border-radius: .4rem; }
	header { position: sticky; top: 0; z-index: 30; }
	header > section{ width: 100%; }
	header > section > img{ height: 1rem; width: unset; }
	header > section > label:first-child { z-index: 20; }
	header > section > label:first-child > img{ margin-left: .5rem; height: 0.7rem; }
	/* header > section > img:last-child { margin-right: .5rem; } */
	header > section > a:last-child img { margin-right: .5rem; height: 1.2rem; }
	section > article { width: 100%; padding-top: 3rem; box-sizing: border-box; }
	header + section {
		background-image: url(../../public/img/img_1_1.png);
		background-repeat: no-repeat;
		background-position-x: 110%;
		background-position-y: 0%;
		background-size: 6.9rem;
	}
	header + section > article { padding-top: 2rem; background-image: unset; }
	header + section > article > div { width: 75%; float: unset; padding: 0rem 1rem; }
	header + section > article > div > h2 { font-size: .8rem; line-height: 1.2rem; padding-bottom: 0.6rem; }
	header + section > article > div > p { font-size: .5rem; }
	header + section > article > div > span { font-size: .6rem; padding-top: 1rem; padding-bottom: 1rem;}
	header + section > article > div > span > b { font-size: .6rem; }
	header + section > article > div > span > b > span { font-size: unset; }
	section > article > div { width: 100%; float: unset; padding: 0 1rem; padding-bottom: 1rem; box-sizing: border-box; }
	section > article > div > h2 { font-size: .8rem; padding-bottom: .6rem; line-height: 1rem; }
	section > article > div > p { font-size: .5rem; color: #131515b3; line-height: .8rem; }
	section > article > div > label { font-size: .6rem; padding-top: 1rem; }
	section > article > div > label > input[type=radio]{ width: 1.7rem; height: 1.7rem; border-radius: 0.3rem; }
	section > article > div > label > input[type=radio]:checked{}
	section > article > article { width: 100%; padding: 1.5rem 1rem; min-height: unset; margin-bottom: -1.5rem; }
	section > article > article > h3 { font-size: .7rem; padding-bottom: 1.5rem; }
	section > article > article > h3 + div > p { font-size: .4rem; }
	section > article > article > h3 + div > p > b { font-size: .6rem; padding: 0 0.2rem; }
	section > article > article > h3 + div > input, section > article > article > h3 + div > .slider { margin: 0rem 0 1rem; }
	section > article > article > h2 { font-size: .6rem; margin-bottom: 0rem; }
	section > article > article > dl {}
	section > article > article > dl > dt { font-size: .5rem; padding-top: 0.5rem; }
	section > article > article > dl > dd { font-size: .5rem; padding-top: 0.5rem; }
	section > article > article > dl + button { margin-top: 1rem; }
	section > article > hgroup { width: 100%; display: block; padding: 0 1rem; box-sizing: border-box; }
	section > article > hgroup > div{ width: 100%; font-size: .4rem; }
	.sec_2 > hgroup > div h3 { font-size: .6rem; }
	.sec_2 > hgroup > div h1 { font-size: 1.5rem; }
	.sec_2 > hgroup > div h1 > a { font-size: .6rem; color: #43AC34; }
	.sec_2 > hgroup > div > p { font-size: .6rem; padding-right: 1.2rem; }
	.sec_2 > hgroup > div > button { box-sizing: border-box; border-radius: 0.4rem; width: 8rem; }
	.sec_2 > hgroup > div > img { height: .5rem; }
	.sec_2 > hgroup > div input[type=checkbox]{ width: .8rem; height: .8rem; border-radius: .2rem; }
	.sec_2 > hgroup > div input[type=checkbox]::before{ width: .2rem; height: .4rem; left: .3rem; }
	.sec_2 > hgroup > div > label { width: 11rem; }
	.sec_3 {
		background-image: url(../../public/img/img_8_1.png);
		background-size: 10.4rem;
		background-position-x: 100%;
		background-position-y: 100%;
		padding: 1rem 1rem 0 1rem;
		box-sizing: border-box;
		min-height: unset;
	}
	.sec_3 > h2 { font-size: .8rem; padding-bottom: 0.5rem; }
	.sec_3 > hgroup { width: 100%; padding: 0; counter-reset: section; padding-left: 1rem; box-sizing: border-box; position: relative; }
	.sec_3 > hgroup::before {
		content: "";
		display: block;
		width: .8rem;
		height: 75%;
		position: absolute;
		left: .28rem;
		top: 1rem;
		border-left: .1rem dashed #1A5B43;
	}
	.sec_3 > hgroup > div { counter-increment: section; position: relative; padding-right: 0; padding-bottom: .6rem; width: 11.5rem; }
	.sec_3 > hgroup > div::before{
		content: counter(section);
		width: .8rem;
		height: .8rem;
		background: #FFFFFF;
		border-radius: 1rem;
		border: .1rem solid #E9EFED;
		line-height: .8rem;
		padding-left: 0rem;
		font-size: .6rem;
		padding-right: 0rem;
		color: #1A5B43;
		display: block;
		position: absolute;
		left: -1.2rem;
		font-weight: bold;
		text-align: center;
	}
	.sec_3 > hgroup > div > div { display: none; }
	.sec_3 > hgroup > div > div > img {}
	.sec_3 > hgroup > div > h3 { display: inline; padding: 0; font-size: .6rem; color: #0D5740; margin-right: .2rem; }
	.sec_3 > hgroup > div > p { display: inline; font-size: .5rem; font-weight: bold; line-height: .8rem; }
	.sec_3 > button { width: unset; padding-left: 1rem; padding-right: 1rem; margin-top: 2.3rem; margin-bottom: 3.4rem; }
	.sec_4 { padding-left: 1rem; padding-right: 1rem; box-sizing: border-box; }
	.sec_4 > h2 { font-size: .8rem; text-align: left; }
	.sec_4 > hgroup { padding: 0; }
	.sec_4 > hgroup > div { text-align: left; width: unset; min-height: 1.3rem; }
	.sec_4 > hgroup > div > div { display: block; width: 1.6rem; float: left; text-align: center; height: 2rem; }
	.sec_4 > hgroup > div > div > img { height: 1rem; }
	.sec_4 > hgroup > div > h3 { display: inline; padding-top: unset; padding-bottom: unset; font-size: .5rem; color: #0D5740; margin-right: .2rem; }
	.sec_4 > hgroup > div > h3:after { content: "."; }
	.sec_4 > hgroup > div > p { display: inline; font-size: .4rem; line-height: .7rem; font-weight: bold; }
	.sec_5 { padding-left: 1rem; padding-right: 1rem; padding-bottom: 0rem; box-sizing: border-box; overflow: hidden; min-height: unset; }
	.sec_5 > h2 { font-size: .8rem; text-align: left; }
	.sec_5 > dl { white-space: nowrap; padding-bottom: 2rem; touch-action: auto; overflow: auto; }
	.sec_5 > dl > dt{ display: contents; }
	.sec_5 > dl > dt > label{
		width: unset;
		font-size: .46rem;
		height: unset;
		border: unset;
		border-right: 0.04rem solid #00000033;
		padding: 0.4rem 1rem 0.4rem 1rem;
	}
	.sec_5 > dl > dd{
		float: unset;
		margin-top: 1rem;
		clear: both;
		width: 100%;
		white-space: normal;
		padding: 1rem 0.6rem 1rem 0.6rem;
		font-size: .55rem;
		border-top: 0.07rem dashed #45B537;
		border-bottom: 0.07rem dashed #45B537;
		min-height: unset;
		font-weight: 500;
		position: sticky;
		left: 0;
	}
	.sec_5 > dl > input:first-child + dt { border-radius:unset; }
	.sec_5 > dl > dt.last{ border-radius:unset; border-bottom: unset; border-right: unset; }
	.sec_5 > dl > dt.last label{ border-right: unset; }
	.sec_5 > dl > dd > h3{ font-size: .6rem; }
	.sec_5 > dl > dd > ul { display:unset; flex-wrap:unset; }
	.sec_5 > dl > dd > ul > li { width: 100%; padding: 0.5rem 0rem 1rem 1rem; }
	.sec_5 > dl > dd > ul > li > a { font-size: .5rem; }
	.sec_5 > dl > dd > ul > li::before { width: .8rem; height: .8rem; background-size: .8rem; left: 0; }
	.sec_5 > dl > dd > p { font-size: .5rem; }
	.sec_5 > dl > dd > dl > dt { font-size: .5rem; }
	.sec_5 > dl > dd > dl > dd { font-size: .5rem; }
	.sec_5 > dl > dd dl > dt { font-size: 0.35rem; }
	.sec_5 > dl > dd dl > dd { font-size: 0.35rem; }
	.sec_5 > dl > dd > ol > li::before { width: 0.6rem; height: 0.8rem; line-height: .8rem; padding-left: 0.2rem; font-size: .6rem; }
	footer > section { width: 100%; padding: 1.3rem 1rem 0rem 1rem; box-sizing: border-box; }
	footer > section p { font-size: .47rem; line-height: .67rem; }
	footer > section > h2 { font-size: .8rem; margin-bottom: 0.3rem; }
	footer > section > hgroup { flex-wrap: wrap; }
	footer > section > hgroup img { height: 0.7rem; margin-bottom: 0.3rem; }
	footer > section > hgroup > div { padding: .8rem 1rem .2rem 0rem; }
	footer > section > hgroup > div > h3 { font-size: .5rem; }
	footer > section > hgroup > div > p { font-size: .36rem; color: #ffffff; }
	footer > section > hgroup button { padding: .8rem 1.2rem; font-size: .46rem; width: 100%; border-radius: .5rem; }
	footer > section + section > dl { width: 100%; font-size: .4rem; }
	footer > section + section > dl > dt { float: unset; }
	footer > section + section > dl > dd { float: unset; padding-top: 0.6rem; }
	footer > section + section > dl > dd a {}
	footer > section p:nth-child(4){ font-size: .36rem; }
	footer > section p:nth-child(5){ font-size: .36rem; }
  footer > section p:nth-child(5) a{color:inherit}
	footer > section > hgroup > div:nth-child(3) img { height: 1rem; margin-bottom: 0; }
	footer > section > hgroup > div:nth-child(3) > h3{ white-space: normal; font-size: .46rem; line-height: .8rem; }
	footer > section > hgroup > div:nth-child(4){ width: 100%; padding-right: 0; margin-bottom: 1rem; }
@media (min-width: 768px) {
  /*.subtext2406{font-size: .8rem;margin: 1rem 0 0}*/
  /*.subtext2406.kostil{margin-top: 3rem}*/
  #sber { display: flex }
  #sber > div > ul > li { list-style: square; margin-left: 2vw }
	html, body { font-size: .9vw; }
	.pa { padding-left: 0rem; font-size: .7rem; }
	.pb { padding-right: 0rem; margin-bottom: 1rem; font-size: .7rem; }
	button { border-radius: .8rem; padding: 1.2rem; font-size: 1rem; }
	input[type=text]{ border: .1rem solid #D5D5D5; padding: 1rem 1.5rem; margin: 1rem 0; font-size: unset; border-radius: .6rem; }
	header { position: unset; top: unset; z-index: unset; }
	header > section{ width: 63vw; }
	header > section > img{ height: unset; width: 11rem; }
	header + section { background-image: unset; }
	header + section > article {
		padding-top: 8rem;
		background-image: url('../../public/img/img_1_1.png');
		background-repeat: no-repeat;
		background-position-x: 40%;
		background-position-y: 101%;
		background-size: 26rem;
	}
	header + section > article > div { width: 24rem; float: left; }
	header + section > article > div > h2 { font-size: 2.3rem; padding-bottom: 2.5rem; line-height: 2.4rem; font-weight: bolder; }
	header + section > article > div > p { font-size: 1.4rem; line-height: 2rem; font-weight: bold; }
	header + section > article > div > span { padding-top: 16rem; font-size: 1.2rem; padding-bottom: unset; }
	header + section > article > div > span > b { font-size: 1.4rem; }
	header + section > article > div > span > b > span { font-size: 4rem; }
	section > article { width: 63vw; padding-top: 6rem; }
	section > article > div { width: 42rem; float: left; }
	section > article > div > p { font-size: unset; line-height: unset; }
	section > article > div > h2 { font-size: 2rem; line-height: 3.5rem; }
	section > article > div > label { font-size: .8rem; }
	section > article > div > label > input[type=radio] { width: 2.7rem; height: 2.7rem; border-radius: .6rem; }
	section > article > hgroup { display: flex; width: 60rem; padding: unset; }
	section > article > hgroup > div { width: 20rem; font-size: .6rem; }
	section > article > article { width: 25rem; padding: 3rem 2.5rem; margin-bottom: 5rem; min-height: 30rem; }
	section > article > article > h3 { font-size: 1.4rem; padding-bottom: 3rem; }
	section > article > article > h3 + div > p { font-size: .8rem; }
	section > article > article > h3 + div > p > b { font-size: 1.2rem; padding: 0 0.4rem; }
	section > article > article > h3 + div > input, section > article > article > h3 + div > .slider { margin: 1rem 0 .4rem; }
	section > article > article > h2 { font-size: 1rem; margin-bottom: 2rem; }
	section > article > article > dl > dt { padding-top: 1rem; font-size: .8rem; }
	section > article > article > dl > dd { padding-top: 1rem; font-size: .8rem; }
	section > article > article > dl + button { margin-top: 2rem; }


  /*section.banner .pcOnly { display: block }*/
  /*section.banner .mobileOnly { display: none }*/
  /*section.banner { background-image: url(../../public/img/fin-moll_banner.svg); background-size: cover; color: #FFFFFF; margin-top: 0 }*/
  /*section.banner svg { width: 14.6rem }*/
  /*section.banner>article { padding-top: 3rem; padding-bottom: 1.5rem }*/
  /*section.banner p:first-child { font-size: 2rem; font-weight: bold; margin-bottom: 26px }*/
  /*section.banner p:nth-child(2) { font-size: 1.875rem; margin-bottom: 2.5rem }*/
  /*section.banner div { margin-bottom: 2.5rem; cursor: pointer; float: none; width: auto; padding: 0 }*/
  /*section.banner p:nth-child(4) { font-size: 0.75rem }*/
  /*section.banner .phone { position: absolute; top: 1.4rem; right: 21.3rem }*/
  /*section.banner .phone>img { width: 32.7rem }*/

	.sec_2 > div > p { padding-bottom: 1.5rem; }
	.sec_2 > hgroup > div > p { font-size: .8rem; }
	.sec_2 > hgroup > div h1 { font-size: 2rem; }
	.sec_2 > hgroup > div h3 { font-size: 1rem; }
	.sec_2 > hgroup > div > img { height: 1rem; }
	.sec_2 > hgroup > div > button { width: 100%; }
	.sec_2 > hgroup > div > label { width: 100%; }
	.sec_2 > hgroup > div input[type=checkbox] { width: 1.5rem; height: 1.5rem; border-radius: .3rem; }
	.sec_2 > hgroup > div input[type=checkbox]::before { width: .5rem; height: .8rem; left: .5rem; }
	.sec_3 { background-image: url(../../public/img/img_2_1.png); background-size: 27rem; background-position-x: 106%; min-height: 35rem; padding:unset; padding-top: 6rem; }
	.sec_3 > h2 { font-size: 1.5rem; padding-bottom: 2rem; }
	.sec_3 > hgroup { width: 55rem; }
	.sec_3 > hgroup::before { display: none; }
	.sec_3 > hgroup > div::before { display: none; }
	.sec_3 > hgroup > div { width: 17.5rem; padding-right: 2rem; }
	.sec_3 > hgroup > div > div { display: block; width: 8rem; height: 5.47rem; border-bottom: .3rem solid #0D5740; }
	.sec_3 > hgroup > div > div > img { height: 5.5rem; }
	.sec_3 > hgroup > div > h3 { display: block; font-size: 1rem; color: #131515; padding-top: 1rem; padding-bottom: .7rem; }
	.sec_3 > hgroup > div > p { display: block; font-size: .7rem; line-height: 1.1rem; }
	.sec_4 > h2 { text-align: center; font-size: 1.8rem; }
	.sec_4 > hgroup > div { width: 15rem; text-align: center; padding: 0 1rem; box-sizing: border-box; }
	.sec_4 > hgroup > div > div { float: unset; width: unset; text-align: unset; height: unset; }
	.sec_4 > hgroup > div > div > img { height: 3rem; }
	.sec_4 > hgroup > div > h3 { display: block; font-size: 1rem; color: #131515; padding-top: 1rem; padding-bottom: 0.7rem; }
	.sec_4 > hgroup > div > p { display: block; font-size: .7rem; line-height: 1.1rem; }
	.sec_5 { padding-bottom: 4rem; min-height: 34rem; }
	.sec_5 > h2 { text-align: center; font-size: 1.8rem; }
	.sec_5 > dl { padding-bottom: 2rem; }
	.sec_5 > dl > dt { display: flex; }
	.sec_5 > dl > dt > label {
		font-size: unset;
		border-right: unset;
		padding: unset;
		display: flex;
		width: 100%;
		text-align: center;
		height: 3.5rem;
		vertical-align: middle;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
	.sec_5 > dl > dt.last { border-radius: 0 0 .5rem .5rem; border-bottom: .1rem solid #E4E4E4; border-right: 0.1rem solid #E4E4E4; }
	.sec_5 > dl > input:first-child + dt { border-radius: .5rem .5rem 0 0; }
	.sec_5 > dl > dd {
		float: right;
		width: 45rem;
		min-height: 14rem;
		padding-top: 1.6rem;
		border-top: .2rem dashed #45B537;
		border-bottom: .2rem dashed #45B537;
		padding: 1.6rem 1.6rem 1.6rem 1.6rem;
		font-weight: bold;
		margin-top: -14rem;
		font-size: unset;
	}
	.sec_5 > dl > dd > ul { display: flex; flex-wrap: wrap; }
	.sec_5 > dl > dd > ul > li { width: 50%; padding: .5rem 0rem 1rem 2.5rem; }
	.sec_5 > dl > dd > ul > li::before { width: 1.8rem; height: 1.8rem; left: .5rem; background-size: 1.5rem; }
	.sec_5 > dl > dd > ul > li > a { font-size: .8rem; }
	.sec_5 > dl > dd > h3 { font-size: 1.1rem; }
	.sec_5 > dl > dd > p { font-size: .8rem; }
	.sec_5 > dl > dd > ol > li > b { line-height: 2.4rem; font-weight: bold; font-size: 1.2rem; }
	.sec_5 > dl > dd > ol > li::before { width: 1rem; height: 1.4rem; line-height: 1.4rem; padding-left: 0.4rem; font-size: .8rem; margin-right: 1rem; }
	.sec_5 > dl > dd dl > dt { font-size: .8rem; }
	.sec_5 > dl > dd dl > dd { font-size: .8rem; }
	footer > section { width: 63vw; padding-top: 6rem; }
	footer > section p { font-size: .8rem; line-height: 1rem; }
	footer > section > h2 { font-size: 2rem; margin-bottom: 1rem; }
	footer > section > hgroup { display: flex; }
	footer > section > hgroup img { height: 1.2rem; margin-bottom: 0.5rem; }
	footer > section > hgroup > div { padding: 1rem .5rem 2rem 0rem; }
	footer > section > hgroup > div > h3 { font-size: .8rem; }
	footer > section > hgroup > div > p { font-size: .8rem; }
	footer > section > hgroup button { font-size: .8rem; padding: 1.4rem 1.2rem; width: unset; }
	footer > section + section > dl { width: 63vw; font-size: unset; }
	footer > section + section > dl > dt { float: left; }
	footer > section + section > dl > dd { float: right; }
	footer > section + section > dl > dd a {}
	footer > section p:nth-child(4){ font-size: .8rem; }
	footer > section p:nth-child(5){ font-size: .8rem; }
	footer > section > hgroup > div:nth-child(3) img { height: 1.5rem; margin-bottom: 0; }
	footer > section > hgroup > div:nth-child(3) > h3{ white-space: nowrap; font-size: .8rem; line-height: .8rem; }
	footer > section > hgroup > div:nth-child(4){ padding: 1.2rem 0; font-size: 1rem; white-space: nowrap; width: unset; }
  /*@media (min-width: 1240px ) {*/
  /*  section.banner .phone { top: 2rem; right: 22rem }*/
  /*  section.banner .phone>img { width: 30rem }*/
  /*}*/
}
</style>
